import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../customComponents/Button";
import Paper from "../widgets/Paper";
import InputText from "../customComponents/InputText";
import Select from "../customComponents/Select";
import { toast, ToastContainer } from "react-toastify";
import DayPlan from "../customComponents/DayPlan";
import TextEditor from "../customComponents/TextEditor";
import DatePicker from "../customComponents/DatePicker";
import { post } from "../utils/api";
import { MultiNewSelect } from "../customComponents/NewMultiSelect";
import LoaderComponent from "./LoaderComponent";
import Upload from "../customComponents/Upload";
import SearchSelect from "../customComponents/SerachSelect";
import GeneratePackagePDF from "./PackagePdf";
import Papa from "papaparse";
import { generateDaywiseCsvRows, parseDaywiseCsvRows } from "../utils/daywiseCsv";
import { slugify } from "../utils/slugify";

const AddPackages = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [days, setDays] = useState([]);
  const [isFirstDayAdded, setIsFirstDayAdded] = useState(false);
  const [selectedValue, setSelectedValue] = useState("single");
  const [formData, setFormData] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showSeasonalFields, setShowSeasonalFields] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date()); // Default to today's date
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [selectedOnwardTransport, setSelectedOnwardTransport] = useState(null);
  const [selectedReturnTransport, setSelectedReturnTransport] = useState(null);
  const [selectedTransfers, setSelectedTransfers] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [extraBFCount, setExtraBFCount] = useState(0);
  const [extraLunchCount, setExtraLunchCount] = useState(0);
  const [extraDinnerCount, setExtraDinnerCount] = useState(0);
  const [tourManagerCount, setTourManagerCount] = useState(0);
  const [numberOfPax, setNumberOfPax] = useState(1);
  const [addOnsAmount, setAddOnsAmount] = useState("");
  const [deviationAmount, setDeviationAmount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  // Authoritative price from the backend single-source engine (POST /computePackagePrice).
  // Null until the first successful response; the local calc is the fallback.
  const [backendPrice, setBackendPrice] = useState(null);
  // Gate the backend price recompute so it does NOT fire during the mount +
  // hydration cascade when a package is opened (we trust the stored price on
  // open). Flipped true on the first genuine user interaction with the form
  // (capture-phase DOM events on the root below); programmatic hydration never
  // fires those events, so this can't misfire. See the price effect below.
  const userInteractedRef = useRef(false);
  const [studentWeekdayTotal, setStudentWeekdayTotal] = useState(0);
  const [studentWeekendTotal, setStudentWeekendTotal] = useState(0);
  const [adultWeekDayTotal, setAdultWeekDayTotal] = useState(0);
  const [adultWeekendTotal, setAdultWeekendTotal] = useState(0);
  const [packageTypeOptions, setPackageTypeOptions] = useState([]);
  const [hotelTypeOptions, setHotelTypeOptions] = useState([]);
  const [hotelNameOptions, setHotelNameOptions] = useState([]);
  const [onwardTransportOptions, setOnwardTransportOptions] = useState([]);
  const [returnTransportOptions, setReturnTransportOptions] = useState([]);
  const [transferOptions, setTransferOptions] = useState([]);
  const [addonOptions, setAddonOptions] = useState([]);
  const [selectedPackageType, setSelectedPackageType] = useState(null);
  const [isPriceModalOpen, setIsPriceModalOpen] = useState(false);
  const [hotelType, setHotelType] = useState("");
  const [accommodationValue, selectedAccommodation] = useState("");
  const [selectedFOC, setSelectedFOC] = useState(0);

  const [settingsGSTValue, setSettingsGSTValue] = useState("");
  const [settingsMarkupValue, setSettingsMarkupValue] = useState("");
  const [settings, setSettings] = useState([]);

  const [hotelPrice, setHotelPrice] = useState(0);
  const [onWardTrnPrice, setOnWardTrnPrice] = useState(0);
  const [returnTrnPrice, setReturnTrnPrice] = useState(0);
  const [transfersPrice, setTransfersPrice] = useState(0);
  const [addOnsPrice, setAddOnsPrice] = useState(0);
  const [markupAmount, setMarkupAmount] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);

  const [editData, setEditData] = useState({}); // or null if you're checking that
  const [freshPackage, setFreshPackage] = useState(null);

  const [formValues, setFormValues] = useState({
    packagetypeid: null,
    packagename: "",
    city: "",
    destination: "",
    noofdays: "",
    noofnights: "",
    hoteltypeid: null,
    onwardtrnid: null,
    returnid: null,
    transferid: null,
    addonid: null,
    extra_bfcount: 0,
    extra_lunchcount: 0,
    extra_dinnercount: 0,
    noofpax: 0,
    foc: "",
    addon_amount: 0,
    deviation_amount: 0,
    price_perhead: 0,
    daywise_plan: [],
    package_image: null,
    currency: "INR",
    total_amount: 0,
    description: "",
    trip_image: "",
  });
  const [dropdownDataLoaded, setDropdownDataLoaded] = useState(false);
  const [showExtraBF, setShowExtraBF] = useState(false);
  const [showExtraLunch, setShowExtraLunch] = useState(false);
  const [showExtraDinner, setShowExtraDinner] = useState(false);
  const [tourManager, setTourManager] = useState(false);
  const [selectedHotelMealPlan, setSelectedHotelMealPlan] = useState("");
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [hotelSelections, setHotelSelections] = useState([
    {
      hotelType: null,
      hotelName: null,
      mealPlan: null,
      day: null,
      noofRooms: 0,
    },
  ]);
  const [transportationSelections, setTransportationSelections] = useState([
    {
      selectedOnwardTransport: null,
      busCount: 1,
    },
  ]);
  const [reducedMarkup, setReducedMarkup] = useState(0);
  const [returnReducedMarkup, setReturnReducedMarkup] = useState(0);
  useEffect(() => {
    if (Array.isArray(editData?.transportationSelections)) {
      const hydrated = editData.transportationSelections.map((item) => ({
        selectedOnwardTransport: item?.selectedOnwardTransport ?? null,
        busCount: item?.busCount ?? 1,
      }));

      setTransportationSelections(hydrated);
    }
  }, [editData]);

  const [returnSelections, setReturnSelections] = useState([
    { selectedReturnTransport: null, busCount: 1 },
  ]);

  const [transferSelections, setTransferSelections] = useState([
    { selectedTransfers: null, busCount: 1 },
  ]);
  const [allMarkups, setAllMarkups] = useState({
    student: {
      weekdays: 0,
      weekends: 0,
      offSeason: 0,
      peakSeason: 0,
    },
    adult: {
      weekdays: 0,
      weekends: 0,
    },
  });
  const [allGSTValues, setAllGSTValues] = useState({
    student: {
      weekdays: 0,
      weekends: 0,
      offSeason: 0,
      peakSeason: 0,
    },
    adult: {
      weekdays: 0,
      weekends: 0,
    },
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInstitution, setSelectedInstitution] = useState(null);
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [itineraryName, setItineraryName] = useState("");
  const [isPublicItinerary, setIsPublicItinerary] = useState(false);
  const [isSubmittingItinerary, setIsSubmittingItinerary] = useState(false);
  const [isDayouting, setIsDayouting] = useState(false);
  const [isDayvisit, setIsDayvisit] = useState(false);
  const [isDomestic, setIsDomestic] = useState(false);
  const [isDomesticDMC, setIsDomesticDMC] = useState(false);
  const [isInternational, setIsInternational] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [dayOptions, setDayOptions] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedHotelName, setSelectedHotelName] = useState(null);
  const [allHotelNames, setAllHotelNames] = useState([]);
  const [paidAdults, setPaidAdults] = useState(0);
  const [offSeasonPrice, setOffSeasonPrice] = useState(0);
  const [peakSeasonPrice, setPeakSeasonPrice] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { packageData, type } = location.state || {};
  const isEdit = location.state?.isEdit;

  useEffect(() => {
    fetchHotelNames(selectedType?.hoteltype);
  }, [selectedType?.hoteltype]);

  useEffect(() => {
    const fetchAllOptions = async () => {
      try {
        await Promise.all([
          fetchPackageTypes(),
          fetchHotelTypes(),
          fetchOnwardTransport(),
          getSettings(),
          // fetchReturnTransport(),
          //fetchTransfers(),
          fetchAddons(),
        ]);
        setDropdownDataLoaded(true); // Mark options as loaded
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      }
    };

    fetchAllOptions();
  }, [selectedPackageType?.label]);

  useEffect(() => {
    fetchOnwardTransport();
  }, [selectedPackageType?.label]);

  useEffect(() => {
    const response = generateOptions(
      formValues.noofnights ? formValues.noofnights : 4
    );
    // console.log("Options", response);
    setDayOptions(response);
  }, [formValues.noofnights]);

  const generateOptions = (maxValue) => {
    // console.log("maxValue", maxValue);
    return Array.from({ length: maxValue }, (_, i) => ({
      label: i + 1,
      value: i + 1,
    }));
  };
  const focHandler = (val, _paxCount) => {
    // FOC loading disabled — cost is recovered via seat/room allocation at booking time
    // if (!_paxCount || _paxCount === 0) return val;
    // const focModifiedValue = val * ((_paxCount + selectedFOC) / _paxCount);
    // return Math.round(focModifiedValue);
    return Math.round(val);
  };

  useEffect(() => {
    if (!selectedFOC) return;
    focHandler();
  }, [selectedFOC]);

  const extraItems = [
    {
      show: showExtraBF,
      label: "Extra BF Count",
      value: extraBFCount,
      setter: setExtraBFCount,
    },
    {
      show: showExtraLunch,
      label: "Extra Lunch Count",
      value: extraLunchCount,
      setter: setExtraLunchCount,
    },
    {
      show: showExtraDinner,
      label: "Extra Dinner Count",
      value: extraDinnerCount,
      setter: setExtraDinnerCount,
    },
    {
      show: tourManager,
      label: "Tour Manager Count",
      value: tourManagerCount,
      setter: setTourManagerCount,
    },
  ];
  const fetchPackageInfo = async (id) => {
    if (!id) {
      toast.error("Missing package id");
      return;
    }
    try {
      const result = await post("/getAllPackages", { packagedetailsid: id, isitenary: false });
      const fresh = result?.data?.[0];
      if (!fresh) {
        toast.error("Failed to load latest package data");
        return;
      }
      setFreshPackage(fresh);
      prePopulateValue(fresh);
    } catch (error) {
      console.error("Error fetching package:", error);
      toast.error("Failed to load latest package data");
    }
  };

  const prePopulateValue = async (data) => {
    const packageData = data;
    console.log("[pcgdt]", packageData);
    // console.log(
    //   packageData?.transportation?.[0]?.selectedOnwardTransport?.label
    // );

    try {
      setShowSeasonalFields(packageData?.seasonal || false);
      const packageType = {
        label: packageData.packagetype,
        value: packageData.packagetype,
        id: packageData.packagetypeid,
      };
      setSelectedPackageType(packageType);
      setIsDayouting(packageData.packagetype === "Day outing");
      setIsDayvisit(
        packageData.packagetype === "Day Visit - Local sightseeing"
      );
      setIsDomestic(packageData.packagetype === "Domestic");
      setIsDomesticDMC(packageData.packagetype === "Domestic - DMC");
      setIsInternational(packageData.packagetype === "International");

      setFormValues({
        packagename: packageData.packagename,
        city: packageData.city,
        destination: packageData.destination,
        noofdays: packageData.noofdays,
        noofnights: packageData.noofnights,
      });
      setHotelSelections(packageData?.packagewise_plan || []);
      setSelectedType(packageData?.packagewise_plan?.[0]?.hotelType);
      const onWardTrn = onwardTransportOptions.find(
        (list) => list?.id === parseInt(packageData?.onwardtrnid)
      );
      const returnWardTrn = onwardTransportOptions.find(
        (list) => list?.id === parseInt(packageData?.returnid)
      );
      const transfers = onwardTransportOptions.find(
        (list) => list?.id === parseInt(packageData?.transferid)
      );
      // const addons = addonOptions.find(
      //   (list) => list?.id === parseInt(packageData?.addonid)
      // );

      const addons = addonOptions.filter((list) =>
        packageData?.addonid.includes(list.id.toString())
      );

      const foc = options.find((list) => list?.value === packageData?.foc);

      setSelectedOnwardTransport(onWardTrn);
      setSelectedReturnTransport(packageData?.return_transportation);
      setSelectedTransfers(transfers);
      setSelectedHotel(hotelType);
      setSelectedAddons(addons);
      setShowExtraBF(
        Array.isArray(addons) &&
        addons.some(
          (addon) =>
            addon.label === "Extra Breakfast" ||
            addon.label.includes("Extra Breakfast")
        )
      );
      setShowExtraLunch(
        Array.isArray(addons) &&
        addons.some((addon) => addon.label.includes("Extra Lunch"))
      );
      setShowExtraDinner(
        Array.isArray(addons) &&
        addons.some((addon) => addon.label.includes("Extra Dinner"))
      );
      setTourManager(
        Array.isArray(addons) &&
        addons.some((addon) => addon.label.includes("Tour manager"))
      );
      setExtraBFCount(Number(packageData.extra_bfcount) || 0);
      setExtraDinnerCount(Number(packageData.extra_dinnercount) || 0);
      setExtraLunchCount(Number(packageData.extra_lunchcount) || 0);
      setTourManagerCount(Number(packageData.extra_tm_count) || 0);
      setNumberOfPax(Number(packageData?.noofpax));
      setSelectedOption({ label: packageData?.foc, value: packageData?.foc });
      const focRatio = parseInt(packageData?.foc?.split(":")[0]);
      const focCount = parseInt(numberOfPax / focRatio);

      setSelectedFOC(isNaN(focCount) ? 0 : focCount);
      setAddOnsAmount(Math.round(Number(packageData?.addon_amount) || 0));
      setDeviationAmount(Number(packageData?.deviation_amount));
      setEditorContents({
        transportation_details:
          packageData?.texteditordata?.transportation_details,
        hotel_details: packageData?.texteditordata?.hotel_details,
        meal_plan: packageData?.texteditordata?.meal_plan,
        inclusions: packageData?.texteditordata?.inclusions,
        exclusions: packageData?.texteditordata?.exclusions,
        terms_conditions: packageData?.texteditordata?.terms_conditions,
        learning_outcomes: packageData?.texteditordata?.learning_outcomes,
        payment_plan: packageData?.texteditordata?.payment_plan || "",
        cancellation_policy: packageData?.texteditordata?.cancellation_policy || "",
        notes: packageData?.texteditordata?.notes || "",
      });
      setPaidAdults(packageData?.adult_count || 0);
      setSelectedDate(new Date(packageData?.dateoftravel));
      let isSeason = packageData?.dateoftravel ? true : false;
      setShowSeasonalFields(isSeason);
      setFormData({
        logo: packageData?.package_image ? packageData?.package_image : null,
      });
      setFormValues((prev) => ({
        ...prev,
        description: packageData?.description || "",
        trip_image: packageData?.trip_image || "",
      }));

      setIsFirstDayAdded(true);
      const fetchedDays = packageData?.daywise_plan || [];
      setDays(fetchedDays.map(d => ({
        ...d,
        timeSlots: (d.timeSlots || []).map(s => ({ ...s, _id: s._id || `db-${Math.random().toString(36).substr(2, 9)}` }))
      })));
      setTransferSelections(packageData?.transfer_transportation);
      setTransportationSelections(
        packageData?.transportation || [
          { selectedTransfers: null, busCount: 1 },
        ]
      );
      setReturnSelections(
        packageData?.transportation?.some(
          (item) =>
            item?.selectedOnwardTransport?.vehicaltype.toLowerCase() != "bus"
        )
          ? packageData?.return_transportation
          : [{ selectedReturnTransport: null, busCount: 1 }]
      );
      // setReturnSelections(
      //   packageData?.return_transportation || [{ selectedReturnTransport: null, busCount: 1 }]
      // )
      // Call the function
      // fetchPackagePlan();
    } catch (error) { }
  };

  const getSettings = async () => {
    try {
      const req = {};
      const response = await post("/getSettings", req);
      setSettings(response.data);
      // Map the settings to the respective fields
      response.data?.forEach((setting) => {
        if (setting.settingsid === 1) {
          setSettingsMarkupValue(setting.settingsvalue);
        } else if (setting.settingsid === 2) {
          setSettingsGSTValue(setting.settingsvalue);
        }
      });
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const fetchInstitutions = async () => {
    try {
      const payload = { type: "institution" };
      const result = await post("/getOptionList", payload);
      setInstitutionOptions(result.data);
    } catch (error) {
      console.error("Error fetching institutions:", error);
    }
  };

  const handleNavigateBack = () => {
    // navigate(-1);
    navigate(location.state?.page ? `/all-packages?page=${location.state.page}` : "/all-packages");
  };

  const handleUploadSelect = (url) => {
    setFormData({ ...formData, logo: url });
  };

  // console.log(
  //   allMarkups?.student[type],
  //   "allMarkups?.student[type] ",
  //   type,
  //   markupAmount
  // );
  const validateFile = (file) => {
    if (!file.type.startsWith("image/")) {
      return "Only image files are allowed.";
    }
    if (file.size > 3 * 1024) {
      return "File size should not exceed 300KB.";
    }
    return null;
  };
  const options = [
    { value: "10:1", label: "10:1" },
    { value: "15:1", label: "15:1" },
    { value: "20:1", label: "20:1" },
    { value: "30:1", label: "30:1" },
    { value: "40:1", label: "40:1" },
  ];

  const handleChange = (option) => {
    setSelectedOption(option);
    if (numberOfPax) {
      const focRatio = parseInt(option?.value?.split(":")[0]);
      const focCount = parseInt(numberOfPax / focRatio);

      setSelectedFOC(isNaN(focCount) ? 0 : focCount);
    } else {
      toast.error("Please enter number of pax");
    }
  };
  // console.log('selecctoption', selectedOption)
  const getHotalPricePrice = (item) => {
    let totalHotelPrice = 0;
    for (let i = 0; i < item?.length; i++) {
      let selectedhotelType = item[i]?.hotelType;
      let selecteMealPlan = item[i]?.mealPlan;
      let selecteDays = item[i]?.day;
      let number_of_days = selecteDays?.length || 1;

      if (!showSeasonalFields || !selectedhotelType) {
        totalHotelPrice += Number(number_of_days * selectedhotelType?.pph || 0);
      } else if (
        isInSeason(
          selectedhotelType?.seasonstart,
          selectedhotelType?.seasonend
        ) &&
        selectedhotelType?.sph
      ) {
        totalHotelPrice += Number(number_of_days * selectedhotelType?.sph);
      } else {
        totalHotelPrice += Number(number_of_days * selecteMealPlan?.pph || 0);
      }
    }

    return totalHotelPrice;
  };

  const calculateHotelRoomPrice = (hotelSelections, noofpax) => {
    let offSeasonTotal = 0;
    let peakSeasonTotal = 0;

    hotelSelections?.forEach((item) => {
      const noOfRooms = parseInt(item.noofRooms) || 0;
      const days = item.day?.length || 0;

      // Use ONLY the selected mealPlan instead of all options
      const selectedOption = item.mealPlan;
      if (!selectedOption) return;

      const label = selectedOption.label?.toLowerCase() || "";
      const pph = parseFloat(selectedOption.pph) || 0;

      // Sharing type just to check how many people per room
      const typeOfSharing = (label) => {
        if (label.includes("single")) return 1;
        if (label.includes("double")) return 2;
        if (label.includes("triple")) return 3;
        if (label.includes("quad") || label.includes("quard")) return 4;
        return 1;
      };

      const multiplier = typeOfSharing(label);

      // ✅ Correct formula: per-person × rooms × sharing × days
      const total = pph * noOfRooms * multiplier * days;

      if (label.includes("off-season")) {
        offSeasonTotal += total;
      }
      if (label.includes("peak season")) {
        peakSeasonTotal += total;
      }
    });

    // Per student price
    if (noofpax > 0) {
      offSeasonTotal /= noofpax;
      peakSeasonTotal /= noofpax;
    }

    return {
      offSeason: offSeasonTotal,
      peakSeason: peakSeasonTotal,
    };
  };

  // ✅ Helper function: getHotelPricesWithDays (Weekdays/Weekends handling)
  // Calculates hotel prices for students and adults, split by weekdays/weekends, based on mealPlan label
  const getHotelPricesWithDays = (
    mealPlans = [],
    numberOfDays = 1,
    isSeason = false
  ) => {
    const result = {
      student: { weekdays: 0, weekends: 0 },
      adult: { weekdays: 0, weekends: 0 },
    };

    if (!Array.isArray(mealPlans) || mealPlans.length === 0) return result;

    mealPlans.forEach((mealPlan) => {
      const label = (mealPlan.label || "").toLowerCase();

      const rawPrice = isSeason ? mealPlan.sph : mealPlan.pph;
      const price = Number(rawPrice);
      if (isNaN(price) || price === 0) return;

      const totalPrice = price * numberOfDays;

      const isAdult = label.includes("adult");
      const isStudent = !isAdult || label.includes("to");

      const isWeekdays = label.includes("weekday");
      const isWeekends = label.includes("weekend");

      // Assign price based on flags
      if (isWeekdays) {
        if (isAdult) result.adult.weekdays += totalPrice;
        if (isStudent) result.student.weekdays += totalPrice;
      }

      if (isWeekends) {
        if (isAdult) result.adult.weekends += totalPrice;
        if (isStudent) result.student.weekends += totalPrice;
      }

      // If neither weekday/weekend explicitly mentioned, add to both
      if (!isWeekdays && !isWeekends) {
        if (isAdult) {
          result.adult.weekdays += totalPrice;
          result.adult.weekends += totalPrice;
        }
        if (isStudent) {
          result.student.weekdays += totalPrice;
          result.student.weekends += totalPrice;
        }
      }
    });

    return result;
  };

  // ✅ Helper function: Markup + GST
  const generateMarkupAndGST = (basePrice) => {
    let finalPrice = basePrice;
    const markupAmount =
      Number(settingsMarkupValue) > 0
        ? ((basePrice - (reducedMarkup + returnReducedMarkup)) *
          Number(settingsMarkupValue)) /
        100
        : 0;
    finalPrice += markupAmount;

    const gstAmount =
      Number(settingsGSTValue) > 0
        ? ((finalPrice - (reducedMarkup + returnReducedMarkup)) * Number(settingsGSTValue)) / 100
        : 0;
    finalPrice += gstAmount;

    return {
      finalPrice: Math.round(finalPrice),
      markupAmount: Math.round(markupAmount),
      gstAmount: Math.round(gstAmount),
    };
  };
  // ✅ Main function: Fully optimized calculateTotalPrice
  const calculateTotalPrice = () => {
    let totalPrice = 0;

    // Utility conversion
    const toNumber = (val) => parseFloat(val) || 0;
    // console.log("hotelSelections", hotelSelections);
    // Domestic hotel calculation
    const domesticHotelPrice = calculateHotelRoomPrice(
      hotelSelections,
      numberOfPax
    );

    let offSeasonPrice = 0;
    let peakSeasonPrice = 0;
    if (selectedPackageType?.label === "Domestic") {
      offSeasonPrice = domesticHotelPrice.offSeason;
      peakSeasonPrice = domesticHotelPrice.peakSeason;
    }
    // console.log(domesticHotelPrice, "domesticHotelPrice");
    // Transportation Calculations
    const calculateTransportCost = (selections, totalPax, setter) => {
      let totalCost = 0;
      selections?.forEach(
        ({
          selectedOnwardTransport,
          selectedReturnTransport,
          selectedTransfers,
          busCount,
        }) => {
          const transport =
            selectedOnwardTransport ||
            selectedReturnTransport ||
            selectedTransfers;

          if (!transport) return;

          const pph = toNumber(transport?.pph);
          const seats = toNumber(transport?.noofseats);
          const count = toNumber(busCount || 1);
          const overhead = toNumber(transport?.overheadprice || 0);
          const noofdays = Number(formValues.noofdays);

          // ✅ accumulate flights for markup exclusion (don’t reset on bus/train)
          // console.log(transport, "transport");
          if (setter) {
            if (transport?.vehicaltype.toLowerCase() === "flight") {
              setter(pph + overhead);
            } else {
              setter(0);
            }
          }

          if (
            transport?.vehicaltype === "Flight" ||
            transport?.vehicaltype === "Train"
          ) {
            totalCost += pph + overhead;
          } else if (selectedTransfers) {
            totalCost += ((pph * noofdays * seats) + overhead) * count;
          } else {
            if (isDayouting || isDayvisit || isInternational || isDomesticDMC) {
              totalCost += ((pph * seats) + overhead) * count;
            } else {
              totalCost += ((pph * noofdays * seats) + overhead) * count;
            }
          }
        }
      );

      // ✅ Check if any flight/train exists
      const hasFlightOrTrain = selections?.some(
        (s) =>
          s?.selectedOnwardTransport?.vehicaltype === "Flight" ||
          s?.selectedReturnTransport?.vehicaltype === "Flight" ||
          s?.selectedTransfers?.vehicaltype === "Flight" ||
          s?.selectedOnwardTransport?.vehicaltype === "Train" ||
          s?.selectedReturnTransport?.vehicaltype === "Train" ||
          s?.selectedTransfers?.vehicaltype === "Train"
      );

      return hasFlightOrTrain ? totalCost : totalCost / totalPax;
    };

    let onwardCost = 0,
      returnCost = 0,
      transferCost = 0;

    if (isDayouting || isDayvisit) {
      onwardCost = calculateTransportCost(
        transportationSelections,
        numberOfPax,
        setReducedMarkup
      );
    } else if (isDomestic || isDomesticDMC) {
      // console.log("onwardCost", transportationSelections);

      onwardCost = calculateTransportCost(
        transportationSelections,
        numberOfPax,
        setReducedMarkup
      );
      returnCost = calculateTransportCost(
        returnSelections,
        numberOfPax,
        setReturnReducedMarkup
      );
      transferCost = calculateTransportCost(
        transferSelections,
        numberOfPax,
        null
      );
    } else if (isInternational) {
      onwardCost = calculateTransportCost(
        transportationSelections,
        numberOfPax,
        setReducedMarkup
      );
      returnCost = calculateTransportCost(
        returnSelections,
        numberOfPax,
        setReturnReducedMarkup
      );
    }
    // Addons calculation (optimized)
    const excludedKeywords = [
      "Extra Breakfast",
      "Extra Lunch",
      "Extra Dinner",
      "Tour Manager",
    ];
    // Addons calculation (optimized)

    const addonsTotal = Array.isArray(selectedAddons)
      ? selectedAddons.reduce((sum, addon) => {
        const label = addon?.label?.toLowerCase() || "";
        if (excludedKeywords.some((k) => label.includes(k.toLowerCase())))
          return sum;

        const pph = toNumber(addon.pph);
        const totalPrice = toNumber(addon.totalprice);

        // Use per-head price if available, else fallback to total price divided by pax
        return (
          sum + (pph > 0 ? pph : numberOfPax ? totalPrice / numberOfPax : 0)
        );
      }, 0)
      : 0;

    // Extra Meals calculation

    const calculateExtra = (label, count) => {
      const addon = selectedAddons.find((a) =>
        a.label.toLowerCase().includes(label.toLowerCase())
      );
      if (!addon) return 0;

      const pph = toNumber(addon.pph);
      const totalPrice = toNumber(addon.totalprice);
      const noofdays = Number(formValues.noofdays);

      // Normal calculation
      return pph > 0
        ? count * pph
        : numberOfPax
          ? (count * totalPrice) / numberOfPax
          : 0;
    };

    const calculateTourManagerExtra = (count) => {
      const addon = selectedAddons.find((a) =>
        a.label.toLowerCase().includes("tour manager")
      );
      if (!addon) return 0;

      const pph = toNumber(addon.pph);
      const totalPrice = toNumber(addon.totalprice);
      const noofdays = Number(formValues.noofdays);

      // If pph is available use it, else apply noOfDays logic
      if (pph > 0) {
        return count * pph;
      }

      if (numberOfPax) {
        return noofdays
          ? (noofdays * count * totalPrice) / numberOfPax
          : (count * totalPrice) / numberOfPax;
      }

      return 0;
    };

    const extraBFTotal = showExtraBF
      ? calculateExtra("Extra Breakfast", extraBFCount)
      : 0;
    const extraLunchTotal = showExtraLunch
      ? calculateExtra("Extra Lunch", extraLunchCount)
      : 0;
    const extraDinnerTotal = showExtraDinner
      ? calculateExtra("Extra Dinner", extraDinnerCount)
      : 0;
    const tourManagerTotal = tourManager
      ? calculateTourManagerExtra(tourManagerCount)
      : 0;

    const localAddonsAmount =
      addonsTotal +
      extraBFTotal +
      extraLunchTotal +
      extraDinnerTotal +
      tourManagerTotal;
    setAddOnsAmount(localAddonsAmount);
    // Common Cost
    const commonCost =
      onwardCost +
      returnCost +
      transferCost +
      (selectedPackageType?.label === "Domestic"
        ? offSeasonPrice
          ? offSeasonPrice
          : peakSeasonPrice
        : Number(getHotalPricePrice(hotelSelections) || 0)) +
      localAddonsAmount +
      Number(deviationAmount || 0);

    const {
      finalPrice: finalCommonCost,
      markupAmount,
      gstAmount,
    } = generateMarkupAndGST(commonCost);
    // console.log(hotelSelections, "hotelSelections");
    // Week based calculation for weekdays/weekends (non domestic)
    const hotelpriceWeektype = getHotelPricesWithDays(
      hotelSelections?.[0]?.options || [],
      Number(formValues.noofdays) || 1
    );

    setStudentWeekdayTotal(
      (hotelpriceWeektype.student.weekdays || 0) + finalCommonCost
    );
    setStudentWeekendTotal(
      (hotelpriceWeektype.student.weekends || 0) + finalCommonCost
    );
    setAdultWeekDayTotal(
      (hotelpriceWeektype.adult.weekdays || 0) + finalCommonCost
    );
    setAdultWeekendTotal(
      (hotelpriceWeektype.adult.weekends || 0) + finalCommonCost
    );
    // console.log(
    //   hotelpriceWeektype,
    //   hotelpriceWeektype,
    //   "hotelpriceWeektype.student.weekdays, hotelpriceWeektype.student.weekends"
    // );
    // Store individual markups and GSTs
    const studentWeekdayCalc = generateMarkupAndGST(
      hotelpriceWeektype.student.weekdays +
      onwardCost +
      returnCost +
      transferCost +
      localAddonsAmount +
      deviationAmount
    );
    const studentWeekendCalc = generateMarkupAndGST(
      hotelpriceWeektype.student.weekends +
      onwardCost +
      returnCost +
      transferCost +
      localAddonsAmount +
      deviationAmount
    );
    const adultWeekdayCalc = generateMarkupAndGST(
      hotelpriceWeektype.adult.weekdays +
      onwardCost +
      returnCost +
      transferCost +
      localAddonsAmount +
      deviationAmount
    );
    const adultWeekendCalc = generateMarkupAndGST(
      hotelpriceWeektype.adult.weekends +
      onwardCost +
      returnCost +
      transferCost +
      localAddonsAmount +
      deviationAmount
    );
    // console.log("check weekday", studentWeekdayCalc, "studentWeekendCalc");
    // console.log("check weekday", adultWeekdayCalc, "adultWeekendCalc");

    setAllMarkups((prev) => ({
      ...prev,
      student: {
        ...prev.student,
        weekdays: studentWeekdayCalc.markupAmount,
        weekends: studentWeekendCalc.markupAmount,
      },
      adult: {
        weekdays: adultWeekdayCalc.markupAmount,
        weekends: adultWeekendCalc.markupAmount,
      },
    }));

    setAllGSTValues((prev) => ({
      ...prev,
      student: {
        ...prev.student,
        weekdays: studentWeekdayCalc.gstAmount,
        weekends: studentWeekendCalc.gstAmount,
      },
      adult: {
        weekdays: adultWeekdayCalc.gstAmount,
        weekends: adultWeekendCalc.gstAmount,
      },
    }));

    // Domestic Specific Off Season / Peak Season for Student
    if (selectedPackageType?.label === "Domestic") {
      const offSeasonCalc = generateMarkupAndGST(
        offSeasonPrice +
        onwardCost +
        returnCost +
        transferCost +
        localAddonsAmount +
        deviationAmount
      );
      const peakSeasonCalc = generateMarkupAndGST(
        peakSeasonPrice +
        onwardCost +
        returnCost +
        transferCost +
        localAddonsAmount +
        deviationAmount
      );

      setAllMarkups((prev) => ({
        ...prev,
        student: {
          ...prev.student,
          offSeason: offSeasonCalc.markupAmount,
          peakSeason: peakSeasonCalc.markupAmount,
        },
      }));

      setAllGSTValues((prev) => ({
        ...prev,
        student: {
          ...prev.student,
          offSeason: offSeasonCalc.gstAmount,
          peakSeason: peakSeasonCalc.gstAmount,
        },
      }));
    }
    // Store breakdown in state for UI
    setHotelPrice(getHotalPricePrice(hotelSelections));
    setOnWardTrnPrice(Math.round(onwardCost));
    setReturnTrnPrice(Math.round(returnCost));
    setTransfersPrice(Math.round(transferCost));
    setAddOnsPrice(addonsTotal);
    setMarkupAmount(markupAmount);
    setGstAmount(gstAmount);
    setOffSeasonPrice(Math.round(offSeasonPrice));
    setPeakSeasonPrice(Math.round(peakSeasonPrice));

    // Final total price logic
    totalPrice =
      (selectedPackageType?.label === "Domestic"
        ? domesticHotelPrice.offSeason + finalCommonCost
        : getHotalPricePrice(hotelSelections) + finalCommonCost) +
      Number(accommodationValue?.pph || 0);

    if (!isDayouting && selectedOption?.value) {
      const [ratio] = selectedOption.value.split(":")?.map(Number);
      if (ratio > 0) totalPrice = (totalPrice * (ratio + 1)) / ratio;
    }

    return Math.round(totalPrice);
  };

  // console.log('returnSelections', returnSelections);
  const handleAddonsChange = (selectedOptions) => {
    setSelectedAddons(selectedOptions);

    setShowExtraBF(
      selectedOptions?.some((option) =>
        option.label.toLowerCase().includes("extra breakfast")
      )
    );
    setShowExtraLunch(
      selectedOptions?.some((option) => option.label.includes("Extra Lunch"))
    );
    setShowExtraDinner(
      selectedOptions?.some((option) => option.label.includes("Extra Dinner"))
    );
    setTourManager(
      selectedOptions?.some((option) => option.label.includes("Tour manager"))
    );
    // console.log(
    //   showExtraBF,
    //   showExtraLunch,
    //   showExtraDinner,
    //   tourManager,
    //   "selectedOptions",
    //   selectedOptions
    // );
    // const total = calculateTotalAddonsPrice(selectedOptions);
    // setAddOnsAmount(total);
  };
  // Assemble a row-shaped payload (same field names the save uses) so the backend
  // can run the canonical packageRowToInputs -> computePackagePrice engine.
  const buildPricingRow = () => ({
    packagetypeid: selectedPackageType?.id,
    noofdays: Number(formValues?.noofdays),
    noofpax: Number(numberOfPax),
    foc: selectedOption?.value,
    deviation_amount: Number(deviationAmount),
    addon_amount: Math.round(Number(addOnsAmount) || 0),
    accommodation_pph: Number(accommodationValue?.pph || 0),
    dateoftravel: selectedDate,
    packagewise_plan: hotelSelections,
    transportation: transportationSelections?.map(
      ({ selectedOnwardTransport, busCount }) => ({ selectedOnwardTransport, busCount })
    ),
    return_transportation: returnSelections?.map(
      ({ selectedReturnTransport, busCount }) => ({ selectedReturnTransport, busCount })
    ),
    transfer_transportation: transferSelections?.map(
      ({ selectedTransfers, busCount }) => ({ selectedTransfers, busCount })
    ),
  });

  useEffect(() => {
    const newTotal = calculateTotalPrice();
    // console.log(newTotal, "newTotal");
    setTotalPrice(newTotal); // immediate local value (breakdowns + fallback)
    // Invalidate any prior backend price so a save during the debounce window
    // falls back to the fresh local calc rather than a stale backend value.
    setBackendPrice(null);

    // Skip the backend call until the user actually interacts with the form.
    // Opening a package should NOT trigger a network recompute — the stored
    // price is already authoritative (the local calc mirrors the engine, so a
    // no-edit save reproduces it). The mount + multi-stage async hydration that
    // runs on open changes these deps programmatically (no DOM events), so
    // userInteractedRef stays false and we return here. The first real edit
    // flips the ref (see the capture handlers on the root element) and every
    // subsequent change recomputes via the backend engine below.
    if (!userInteractedRef.current) {
      return;
    }

    // Debounced authoritative recompute from the backend single-source engine.
    const handle = setTimeout(async () => {
      try {
        const resp = await post("/computePackagePrice", { row: buildPricingRow() });
        const priced = resp?.data;
        if (priced && typeof priced.price_perhead === "number" && !Number.isNaN(priced.price_perhead)) {
          setBackendPrice(priced);
          setTotalPrice(priced.price_perhead);
        }
      } catch (e) {
        // Network/compute error: keep the local calc value already set above.
      }
    }, 500);
    return () => clearTimeout(handle);
  }, [
    // selectedHotel,
    selectedOnwardTransport,
    selectedReturnTransport,
    selectedTransfers,
    selectedAddons,
    extraBFCount,
    extraLunchCount,
    extraDinnerCount,
    tourManagerCount,
    tourManager,
    showExtraBF,
    showExtraLunch,
    showExtraDinner,
    numberOfPax,
    selectedOption,
    deviationAmount,
    days?.length,
    showSeasonalFields,
    selectedDate,
    hotelSelections,
    accommodationValue,
    transportationSelections,
    returnSelections,
    transferSelections,
    selectedPackageType?.label,
    reducedMarkup,
    returnReducedMarkup,
  ]);
  const fetchPackageTypes = async () => {
    try {
      const payload = { type: "packagetype" };
      const result = await post("/getOptionList", payload);
      const options = result.data?.map((item) => ({
        value: item?.value,
        label: item?.label,
        id: item?.value,
      }));
      setPackageTypeOptions(options);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  };
  const fetchHotelNames = async (name) => {
    try {
      const payload = { type: "hotelname_hoteltype" };
      const result = await post("/getOptionList", payload);
      // console.log('name   ............>>>>', name);
      const filteredoptions = result.data.filter(
        (item) => item.hoteltype?.toLowerCase() === name?.toLowerCase()
      );
      // console.log(filteredoptions, "filter -->>>hotelNameOptions");
      setHotelNameOptions(filteredoptions);
    } catch (error) {
      console.error("Error fetching hotel types:", error);
    }
  };
  const fetchHotelTypes = async () => {
    try {
      const payload = { type: "hotelname_hoteltype" };
      const result = await post("/getOptionList", payload);

      if (!isEdit) {
        setHotelNameOptions(result.data);
      }

      setAllHotelNames(result.data);
      if (isDomestic || isDomesticDMC || isInternational) {
				const domesticOptions = result.data
					.filter(
						item =>
							typeof item.hoteltype === "string" &&
							item.hoteltype.toLowerCase().includes("hotel"), //||
						// item.hoteltype?.toLowerCase().includes("resort")
					)
					.filter(
						(item, index, self) =>
							index === self.findIndex(t => t.hoteltype === item.hoteltype),
					);
				// console.log('first', selectedPackageType?.label, 'second', domesticOptions);

				setHotelTypeOptions(domesticOptions);
			} else {
				const options = [
					...new Map(
						result.data
							.filter(
								item =>
									typeof item.hoteltype === "string" &&
									[
										"Resort",
										"Amusement Park",
										"Campsite",
										"Industrial Visit",
									].includes(item.hoteltype),
							)
							.map(item => [item.hoteltype, item]),
					).values(),
				];

				setHotelTypeOptions(options);
			}
    } catch (error) {
      console.error("Error fetching hotel types:", error);
    }
  };

  // console.log(hotelTypeOptions, "selectedPackageType");
  const fetchOnwardTransport = async () => {
    try {
      const payload = {
        type: "vehicaltype_vehicalname",
        vehicleType: selectedPackageType?.label
          ?.toLowerCase()
          .includes("International")
          ? "Flight"
          : selectedPackageType?.label
            ?.toLowerCase()
            .includes("day outing" || "Day Visit")
            ? "Volvo 55 multiaxil, Volvo 45 seater, Bus 49 seater, Bus 40 seater, Bus 36 seater, Bus 30 seater, Mini bus 22 seater, Tempo traveller 18 seater, Tempo traveller 12 seater, 7 Seater car, 5 Seater car"
            : "",
      };
      const result = await post("/getOptionList", payload);
      // const transferResult = await post("/getOptionList", {
      //   type: "vehicaltype_vehicalname",
      //   vehicleType:
      //     "5 Seater car, Mini bus 22 seater, 7 Seater car, Bus 49 seater",
      // });
      // const options = result.data.map((item) => ({
      //   value: item.id,
      //   label: item.label,
      //   pph: item.pph,
      // }));
      setOnwardTransportOptions(result.data);
      setReturnTransportOptions(result.data);
      setTransferOptions(result.data);
      // setTransferOptions(transferResult.data);
    } catch (error) {
      console.error("Error fetching onward transport:", error);
    }
  };
  // Constants for travel package types
  const PACKAGE_TYPES = {
    Dayouting: "Day outing",
    DayVisit: "Day Visit - Local sightseeing",
    Domestic: "Domestic",
    DomesticDMC: "Domestic DMC",
    International: "International",
  };

  // Filter transport options based on package type
  const filterTransportOptions = (options, packageLabel) => {
    return options.filter((opt) => {
      const vehicalType = opt.vehicaltype?.toLowerCase();
      if (
        packageLabel === PACKAGE_TYPES.Dayouting ||
        packageLabel === PACKAGE_TYPES.DayVisit
      ) {
        return vehicalType?.includes("seater") || vehicalType?.includes("car");
      }
      if (packageLabel === PACKAGE_TYPES.International) {
        return vehicalType === "flight";
      }
      return true; // Domestic/DMC
    });
  };

  // UI Handlers
  const handleAddTransField = () => {
    setTransportationSelections((prev) => [
      ...prev,
      {
        selectedOnwardTransport: null,
        busCount: 1,
      },
    ]);
  };

  const handleDeleteTransField = (index) => {
    setTransportationSelections((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpdateBusCount = (index, count) => {
    setTransportationSelections((prev) => {
      const updated = [...prev];
      updated[index].busCount = Number(count);
      return updated;
    });
  };

  const handleOnwardTransportChange = (index, selectedOption) => {
    // Update onward transport
    setTransportationSelections((prev) => {
      const updated = [...prev];
      updated[index].selectedOnwardTransport = selectedOption;
      return updated;
    });

    // Only set return for NON-domestic packages
    if (!(isDomestic || isDomesticDMC)) {
      if (!selectedOption?.vehicaltype?.toLowerCase().includes("bus")) {
        setReturnSelections([{ selectedReturnTransport: null, busCount: 1 }]);
      } else {
        setReturnSelections([{ selectedReturnTransport: null }]);
      }
    } else {
      // For domestic, reset return selections if onward is flight/train
      if (
        selectedOption?.vehicaltype === "Flight" ||
        selectedOption?.vehicaltype === "Train"
      ) {
        setReturnSelections([{ selectedReturnTransport: null }]);
      }
    }
  };

  const filterTransferOptions = (options, packageType) => {
    if (!options) return [];

    const lowerType = packageType?.toLowerCase();

    if (lowerType === "international") {
      return options?.filter((opt) =>
        opt.label.toLowerCase().includes("flight")
      );
    }

    if (lowerType === "day outing" || lowerType === "day visit") {
      return options.filter(
        (opt) =>
          !opt.label.toLowerCase().includes("train") &&
          !opt.label.toLowerCase().includes("flight")
      );
    }

    return options; // for domestic and others
  };

  const handleTransfersChange = (option, index) => {
    const updatedTransfers = [...transferSelections];
    updatedTransfers[index].selectedTransfers = option;
    setTransferSelections(updatedTransfers);
  };

  const handleTransferBusCountChange = (index, count) => {
    const updatedTransfers = [...transferSelections];
    updatedTransfers[index].busCount = count;
    setTransferSelections(updatedTransfers);
  };

  const handleAddTransferField = () => {
    setTransferSelections([
      ...transferSelections,
      { selectedTransfers: null, busCount: "1" },
    ]);
  };

  const handleDeleteTransferField = (index) => {
    const updatedTransfers = [...transferSelections];
    updatedTransfers.splice(index, 1);
    setTransferSelections(updatedTransfers);
  };

  // Handle Return Transport Select Change
  const handleReturnTransportChange = (index, selectedOption) => {
    setReturnSelections((prev) => {
      const updated = [...prev];
      updated[index].selectedReturnTransport = selectedOption;
      return updated;
    });
  };

  const fetchAddons = async () => {
    try {
      const payload = { type: "addons_price" };
      const result = await post("/getOptionList", payload);

      if (!Array.isArray(result.data)) {
        console.error("Invalid data format:", result.data);
        return;
      }

      // Add color property for UI styling
      const optionsWithPPH = result.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.label,
      }));
      setAddonOptions(optionsWithPPH);
    } catch (error) {
      console.error("Error fetching addons:", error);
    }
  };
  // Add handlers for form inputs
  const handlePackageTypeChange = (option) => {
    setSelectedPackageType(option);
    setFormValues((prev) => ({ ...prev, packagetypeid: option.value }));

    // Check if Day outing is selected
    const isDayoutingSelected = option.label === "Day outing";
    setIsDayouting(isDayoutingSelected);

    // Check if Day Visit - Local sightseeing is selected
    const isDayvisitSelected = option.label?.includes("Day Visit");
    setIsDayvisit(isDayvisitSelected);

    // Check if Domestic is selected
    const isDomesticSelected = option.label === "Domestic";
    setIsDomestic(isDomesticSelected);

    const isDomesticDMCSelected = option.label === "Domestic - DMC";
    setIsDomesticDMC(isDomesticDMCSelected);
    // Check if International is selected
    const isInternationalSelected = option.label === "International";
    setIsInternational(isInternationalSelected);

    // Reset hotel and meal plan if Day outing is selected
    if (isDayoutingSelected) {
      setSelectedHotel(null);
      setSelectedHotelMealPlan(null);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Escape single quotes for Postgres
    const safeValue = value.replace(/'/g, "`");
    setFormValues((prev) => ({
      ...prev,
      [name]: safeValue,
    }));
  };

  const validateFields = () => {
    if (!selectedPackageType?.id) {
      toast.error("Please select package type");
      return false;
    }

    if (!formValues.packagename?.trim()) {
      toast.error("Package name is required");
      return false;
    }

    if (!formValues.city?.trim()) {
      toast.error("Source city is required");
      return false;
    }

    if (!formValues.destination?.trim()) {
      toast.error("Destination is required");
      return false;
    }

    if (!isDayouting && !isDayvisit) {
      const noofdays = Number(formValues.noofdays);
      const noofnights = Number(formValues.noofnights);

      if (!noofdays || noofdays <= 0) {
        toast.error("Number of days must be greater than 0");
        return false;
      }

      if (!noofnights || noofnights <= 0) {
        toast.error("Number of nights must be greater than 0");
        return false;
      }
    }
    // console.log(hotelSelections, "hotelSelections");
    if (!isDomesticDMC && !isDayvisit && !isInternational && !isDayouting) {
      hotelSelections?.forEach((field, index) => {
        if (!field?.hotelType?.value) {
          // throw new Error(
          //   `Hotel Type is required for plan ${index + 1}.`
          // );
          toast.error(`Hotel Type is required for plan ${index + 1}.`);
          return false;
        }
        if (!field?.mealPlan?.label) {
          toast.error(`Meal Plan is required for plan ${index + 1}.`);
          return false;
        }
        if (field?.day?.length == 0) {
          toast.error(`Day is required for plan ${index + 1}.`);
          return false;
        }
      });
    }
    // console.log(transportationSelections, "transportationSelections");
    if (!transportationSelections[0]?.selectedOnwardTransport?.id) {
      toast.error("Please select onward transportation");
      return false;
    }

    if (
      Array.isArray(returnSelections) &&
      returnSelections.length > 0 &&
      returnSelections[0]?.selectedReturnTransport != null &&
      !returnSelections[0]?.selectedReturnTransport?.id &&
      selectedPackageType?.label === "International"
    ) {
      toast.error("Please select return transportation");
      return false;
    }

    if (!numberOfPax || numberOfPax <= 0) {
      toast.error("Number of pax must be greater than 0");
      return false;
    }

    if (showSeasonalFields && !selectedDate) {
      toast.error("Please select date of travel");
      return false;
    }

    if (!days.length) {
      toast.error("Please add at least one day plan");
      return false;
    }

    // for (let day of days) {
    //   if (!day.planName?.trim()) {
    //     toast.error(`Please add plan name for day ${day.dayNumber}`);
    //     return false;
    //   }
    //   if (!day.timeSlots?.length) {
    //     toast.error(`Please add time slots for day ${day.dayNumber}`);
    //     return false;
    //   }
    // }

    if (editorContents?.transportation_details?.length < 1) {
      toast.error("Transportation details are required");
      return false;
    }
    if (editorContents?.hotel_details?.length < 1) {
      toast.error("Hotel details are required");
      return false;
    }
    if (editorContents?.meal_plan?.length < 1) {
      toast.error("Meal plan details are required");
      return false;
    }
    if (editorContents?.inclusions?.length < 1) {
      toast.error("Inclusions are required");
      return false;
    }
    if (editorContents?.exclusions?.length < 1) {
      toast.error("Exclusions are required");
      return false;
    }
    if (editorContents?.terms_conditions?.length < 1) {
      toast.error("Terms and conditions are required");
      return false;
    }
    if (editorContents?.learning_outcomes?.length < 1) {
      toast.error("Learning outcomes are required");
      return false;
    }

    return true;
  };

  const handleSavePackage = async () => {
    if (!validateFields()) {
      return;
    }
    try {
      const formattedDays = days.map((day) => ({
        dayNumber: day.dayNumber,
        timeSlots: day.timeSlots || [],
        planName: day.planName,
        daywiseImage: day.daywiseImage,
      }));
      const addonIds = Array.isArray(selectedAddons)
        ? `{${selectedAddons.map((addon) => addon.id).join(",")}}`
        : selectedAddons?.id
          ? `{${selectedAddons.id}}`
          : null;

      let hotelPlan = [];

      hotelSelections?.forEach((field) => {
        hotelPlan.push({
          hotelType: field?.hotelType?.value,
          mealPlan: field?.mealPlan?.value,
          day: Array.isArray(field.day)
            ? `{${field.day.map((addon) => addon.value).join(",")}}`
            : field.day?.value
              ? `{${field.day.value}}`
              : null,
        });
      });
      const basePayload = {
        packagetypeid: selectedPackageType?.id,
        packagename: formValues?.packagename,
        cityid: formValues?.city,
        destination: formValues?.destination,
        noofdays: Number(formValues?.noofdays),
        noofnights: Number(formValues?.noofnights),
        hoteltypeid: selectedHotel?.id,
        onwardtrnid: selectedOnwardTransport?.id,
        returnid: selectedReturnTransport?.id,
        transferid: selectedTransfers?.id,
        addonid: addonIds,
        extra_bfcount: Number(extraBFCount),
        extra_lunchcount: Number(extraLunchCount),
        extra_dinnercount: Number(extraDinnerCount),
        extra_TMCount: Number(tourManagerCount), // fixed naming for consistency
        noofpax: Number(numberOfPax),
        foc: selectedOption?.value,
        focCount: selectedFOC,
        adult_count: Number(paidAdults || 0),
        addon_amount: Math.round(Number(addOnsAmount) || 0),
        deviation_amount: Number(deviationAmount),
        price_perhead: backendPrice?.price_perhead ?? focHandler(
          Math.round(
            selectedPackageType?.label === "Domestic"
              ? offSeasonPrice > 0
                ? offSeasonPrice +
                onWardTrnPrice +
                returnTrnPrice +
                transfersPrice +
                addOnsAmount +
                deviationAmount +
                (typeof allMarkups?.student?.offSeason === "number"
                  ? allMarkups.student.offSeason
                  : markupAmount) +
                (typeof allGSTValues?.student?.offSeason === "number"
                  ? allGSTValues.student.offSeason
                  : gstAmount)
                : peakSeasonPrice > 0
                  ? peakSeasonPrice +
                  onWardTrnPrice +
                  returnTrnPrice +
                  transfersPrice +
                  addOnsAmount +
                  deviationAmount +
                  (typeof allMarkups?.student?.peakSeason === "number"
                    ? allMarkups.student.peakSeason
                    : markupAmount) +
                  (typeof allGSTValues?.student?.peakSeason === "number"
                    ? allGSTValues.student.peakSeason
                    : gstAmount)
                  : 0
              : typeof totalAmountStudentWeekDays === "number" &&
                totalAmountStudentWeekDays > 0
                ? totalAmountStudentWeekDays +
                (allMarkups?.student?.weekdays || 0) +
                (allGSTValues?.student?.weekdays || 0)
                : typeof totalAmountAdultWeekdays === "number" &&
                  totalAmountAdultWeekdays > 0
                  ? totalAmountAdultWeekdays +
                  (allMarkups?.adult?.weekdays || 0) +
                  (allGSTValues?.adult?.weekdays || 0)
                  : 0
          ),
          numberOfPax
        ),
        daywise_plan: formattedDays,
        package_image: formData?.logo || "",
        description: formValues?.description || "",
        trip_image: formValues?.trip_image || "",
        currency: "INR",
        total_amount: backendPrice?.total_amount ?? Number(totalPrice * numberOfPax),
        type: isEdit ? "update" : "insert",
        texteditorData: editorContents,
        city: formValues?.city,
        dateoftravel: selectedDate,
        isAudit: true,
        user: user?.username || "N/A",
        isitinerary: false,
        hotel_mealplan:
          typeof selectedHotelMealPlan === "string"
            ? selectedHotelMealPlan
            : selectedHotelMealPlan?.value,
        packagewise_plan: hotelSelections,
        transportation: JSON.stringify(
          transportationSelections?.map(
            ({ selectedOnwardTransport, busCount }) => ({
              selectedOnwardTransport,
              busCount,
            })
          )
        ),
        return_transportation: JSON.stringify(
          returnSelections?.map(({ selectedReturnTransport, busCount }) => ({
            selectedReturnTransport,
            busCount,
          }))
        ),
        transfer_transportation: JSON.stringify(
          transferSelections?.map(({ selectedTransfers, busCount }) => ({
            selectedTransfers,
            busCount,
          }))
        ),
      };
      // console.log(basePayload, "basePayload");
      //       return
      const payload = location.state?.isEdit
        ? {
          ...basePayload,
          packagedetailsid: location.state?.packageData?.packagedetailsid,
        }
        : basePayload;

      const response = await post("/addPackage", payload);

      if (response.status) {
        toast.success(
          isEdit ? "Package updated successfully" : "Package added successfully"
        );
        setTimeout(() => {
          navigate(location.state?.page ? `/all-packages?page=${location.state.page}` : "/all-packages");
        }, 1500);
      } else {
        toast.error("Failed to save package");
      }
    } catch (error) {
      toast.error("An error occurred while saving the package");
    }
  };

  const handleConvertToItinerary = () => {
    setIsModalOpen(true);
    fetchInstitutions();
  };
  const [editorContents, setEditorContents] = useState({
    transportation_details: "",
    hotel_details: "",
    meal_plan: "",
    inclusions: "",
    exclusions: "",
    terms_conditions: "",
    learning_outcomes: "",
    payment_plan: "",
    cancellation_policy: "",
    notes: "",
  });

  const handleEditorChange = (content, field) => {
    // Escape single quotes for Postgres (O'Reilly -> O''Reilly)
    const safeContent = content.replace(/'/g, "`");

    setEditorContents((prev) => ({
      ...prev,
      [field]: safeContent,
    }));
  };

  // const handleDayPlanChange = useCallback((dayNumber, planData) => {
  //   setDays((prevDays) => {
  //     const dayIndex = prevDays.findIndex((day) => day.dayNumber === dayNumber);
  //     if (dayIndex === -1) return prevDays;
  //     // const existing = prevDays[dayIndex];
  //     // ;Add commentMore actions
  //     // const isSame =
  //     //   existing.planName === planData?.planName &&
  //     //   existing.daywiseImage === planData?.formData?.logo &&
  //     //   JSON.stringify(existing.timeSlots) ===
  //     //     JSON.stringify(planData?.timeSlots);

  //     // if (isSame) return prevDays; // ⛔ avoid redundant state update
  //     const newDays = [...prevDays];
  //     newDays[dayIndex] = {
  //       dayNumber,
  //       timeSlots: planData?.timeSlots,
  //       planName: planData?.planName,
  //       daywiseImage: planData?.formData?.logo,
  //     };
  //     return newDays;
  //   });
  // }, []);
  // To minimize unnecessary rerenders, ensure that handleDayPlanChange is memoized (with useCallback) and only updates state if the data actually changed.
  // You can add a shallow comparison to avoid setting state if nothing changed for that day.

  // Handles update from each DayPlan (including image changes)
  const handleDayPlanChange = useCallback((dayNumber, planData) => {
    console.log("planData", planData);
    setDays((prevDays) =>
      prevDays.map((day) =>
        day.dayNumber === dayNumber
          ? {
            ...day,
            planName: planData.planName,
            timeSlots: planData.timeSlots,
            daywiseImage: planData.daywiseImage,
          }
          : day
      )
    );
  }, []);

  const handleAddDay = () => {
    setDays((prevDays) => {
      const newDay = {
        dayNumber: prevDays.length
          ? Math.max(...prevDays.map((d) => d.dayNumber)) + 1
          : 1,
        planName: "",
        timeSlots: [],
        daywiseImage: null,
      };
      return [...prevDays, newDay];
    });

    setIsFirstDayAdded(true); // 👈 ensures grid renders
  };
  const handleDeleteDay = (dayNumber) => {
    setDays((prevDays) =>
      prevDays.filter((day) => day.dayNumber !== dayNumber)
    );
  };

  const handleMoveDayUp = (index) => {
    if (index === 0) return;
    setDays((prevDays) => {
      const newDays = [...prevDays];
      [newDays[index - 1], newDays[index]] = [newDays[index], newDays[index - 1]];
      return newDays.map((day, i) => ({ ...day, dayNumber: i + 1 }));
    });
  };

  const handleMoveDayDown = (index) => {
    if (index === days.length - 1) return;
    setDays((prevDays) => {
      const newDays = [...prevDays];
      [newDays[index], newDays[index + 1]] = [newDays[index + 1], newDays[index]];
      return newDays.map((day, i) => ({ ...day, dayNumber: i + 1 }));
    });
  };

  const handleInstitutionSelect = (option) => {
    setSelectedInstitution(option);
  };
  const handleConvertToEnquiry = async () => {
    if (!validateFields()) {
      return;
    }

    if (!isPublicItinerary && !selectedInstitution) {
      toast.error("Please select an institution");
      return;
    }

    if (!itineraryName?.trim()) {
      toast.error("Please enter itinerary name");
      console.log("🚀 ~ handleConvertToEnquiry ~ basePayload:", basePayload);
      return;
    }
    const formattedDays = days.map((day) => ({
      dayNumber: day.dayNumber,
      timeSlots: day.timeSlots || [],
      planName: day.planName,
      daywiseImage: day.daywiseImage,
    }));

    const addonIds = Array.isArray(selectedAddons)
      ? `{${selectedAddons.map((addon) => addon.id).join(",")}}`
      : selectedAddons?.id
        ? `{${selectedAddons.id}}`
        : null;

    let hotelPlan = [];

    hotelSelections?.forEach((field, index) => {
      hotelPlan.push({
        hotelType: field?.hotelType?.value,
        mealPlan: field?.mealPlan?.value,
        day: Array.isArray(field.day)
          ? `{${field.day.map((addon) => addon.value).join(",")}}`
          : field.day?.value
            ? `{${field.day.value}}`
            : null,
      });
    });
    let accomdaTion;

    const payload = { type: "accommodationtype" };
    const result = await post("/getOptionList", payload);
    if (result.data.length > 0) {
      accomdaTion = result.data.filter(
        (list) => list.label == accommodationValue
      );
    }

    const basePayload = {
      packagetypeid: selectedPackageType?.id,
      packagetype: selectedPackageType?.label,
      packagename: formValues.packagename,
      cityid: formValues.city,
      destination: formValues.destination,
      noofdays: Number(formValues.noofdays),
      noofnights: Number(formValues.noofnights),
      hoteltypeid: selectedHotel?.id,
      hoteltype: selectedHotel?.label,
      onwardtrnid: selectedOnwardTransport?.id,
      onward: selectedOnwardTransport?.label,
      returnid: selectedReturnTransport?.id,
      return: selectedReturnTransport?.label,
      transferid: selectedTransfers?.id,
      transfer: selectedTransfers?.label,
      addonid: addonIds,
      extra_bfcount: Number(extraBFCount),
      extra_lunchcount: Number(extraLunchCount),
      extra_dinnercount: Number(extraDinnerCount),
      extra_TMCount: Number(tourManagerCount),
      noofpax: Number(numberOfPax),
      foc: selectedOption?.value,
      focCount: selectedFOC,
      addon_amount: Math.round(Number(addOnsAmount) || 0),
      deviation_amount: Number(deviationAmount),
      price_perhead: focHandler(
        Math.round(
          selectedPackageType?.label === "Domestic"
            ? offSeasonPrice > 0
              ? offSeasonPrice +
              onWardTrnPrice +
              returnTrnPrice +
              transfersPrice +
              addOnsAmount +
              deviationAmount +
              (typeof allMarkups?.student?.offSeason === "number"
                ? allMarkups.student.offSeason
                : markupAmount) +
              (typeof allGSTValues?.student?.offSeason === "number"
                ? allGSTValues.student.offSeason
                : gstAmount)
              : peakSeasonPrice > 0
                ? peakSeasonPrice +
                onWardTrnPrice +
                returnTrnPrice +
                transfersPrice +
                addOnsAmount +
                deviationAmount +
                (typeof allMarkups?.student?.peakSeason === "number"
                  ? allMarkups.student.peakSeason
                  : markupAmount) +
                (typeof allGSTValues?.student?.peakSeason === "number"
                  ? allGSTValues.student.peakSeason
                  : gstAmount)
                : 0
            : typeof totalAmountStudentWeekDays === "number" &&
              totalAmountStudentWeekDays > 0
              ? totalAmountStudentWeekDays +
              (allMarkups?.student?.weekdays || 0) +
              (allGSTValues?.student?.weekdays || 0)
              : typeof totalAmountAdultWeekdays === "number" &&
                totalAmountAdultWeekdays > 0
                ? totalAmountAdultWeekdays +
                (allMarkups?.adult?.weekdays || 0) +
                (allGSTValues?.adult?.weekdays || 0)
                : 0
        ),
        numberOfPax
      ),
      daywise_plan: formattedDays,
      total_amount: totalPrice,
      package_image: formData?.logo ? formData?.logo : "",
      description: formValues?.description || "",
      trip_image: formValues?.trip_image || "",
      currency: "INR",
      total_amount: Number(totalPrice * numberOfPax),
      texteditorData: editorContents,
      city: formValues.city,
      source: formValues.city,
      dateoftravel: selectedDate,
      isAudit: true,
      user: user?.username || "N/A",
      hotel_mealplan:
        typeof selectedHotelMealPlan === "string"
          ? selectedHotelMealPlan
          : selectedHotelMealPlan?.value,
      isPackageType: location.state?.packageData?.packagedetailsid
        ? "update"
        : "insert",
      isitinerary: true,
      itineraryname: itineraryName,
      institutionid: selectedInstitution?.id,
      type: "insert",
      itinerary_travel: selectedDate,
      schoolname: selectedInstitution?.label,
      user: user?.username || "N/A",
      packagewise_plan: hotelSelections,
      packagedetailsid: location.state?.packageData?.packagedetailsid,
      hotelType: hotelSelections?.[0]?.hotelType?.hoteltype,
      accomdaTion: accomdaTion && accomdaTion.length > 0 ? accomdaTion[0] : {},
      adult_count: Number(paidAdults || 0),
      transportation: JSON.stringify(
        transportationSelections?.map(
          ({ selectedOnwardTransport, busCount }) => ({
            selectedOnwardTransport,
            busCount,
          })
        )
      ),
      return_transportation: JSON.stringify(
        returnSelections?.map(({ selectedReturnTransport, busCount }) => ({
          selectedReturnTransport,
          busCount,
        }))
      ),
      transfer_transportation: JSON.stringify(
        transferSelections?.map(({ selectedTransfers, busCount }) => ({
          selectedTransfers,
          busCount,
        }))
      ),
    };

    setIsSubmittingItinerary(true);
    try {
      const response = await post("/addItinerary", {
        ...basePayload,
        ...(isPublicItinerary ? { is_public: true } : {}),
      });
      setIsModalOpen(false);
      if (isPublicItinerary) {
        toast.success("Public itinerary created");
        navigate("/all-packages");
      } else {
        const payload = {
          ...basePayload,
          packagedetailsid:
            response?.data?.packagedetailsid ||
            location.state?.packageData?.packagedetailsid,
        };
        navigate("/add-enquiry", {
          state: {
            institution: selectedInstitution,
            packageData: payload,
            type: "insert",
            itineraryName: itineraryName,
            itineraryId: response?.data?.itinerarydetailsid,
          },
        });
      }
    } catch (error) {
      toast.error("Error creating itinerary");
    } finally {
      setIsSubmittingItinerary(false);
    }
  };

  const fetchHotelMealPlan = async (id) => {
    try {
      const payload = {
        type: "hotelname_hotelwiseplan",
        hotelid: id,
        hoteltype:
          selectedPackageType?.label === "Domestic" ? "seasontype" : "others",
      };
      const result = await post("/getOptionList", payload);

      const formattedOptions = result.data.map((item) => ({
        value: item.id,
        label: item.label,
        pph: item.pph,
        sph: item.sph,
        id: item.id,
        accommodationType: item.accommodationtype,
      }));
      // console.log(result.data, "result.data meal plan");
      return formattedOptions;
    } catch (error) {
      console.error("Error fetching hotel meal plans:", error);
      return [];
    }
  };

  useMemo(() => {
    if (isEdit && dropdownDataLoaded) {
      // Re-fetch the latest package by id; the nav-state snapshot only
      // carries the id and page, so hydrating from it would be stale.
      fetchPackageInfo(packageData?.packagedetailsid);
    }
  }, [dropdownDataLoaded]);

  const handleHotelChanges = async (selectedOption, index, field) => {
    const updatedSelections = [...hotelSelections];
    // console.log("updatedSelections", selectedOption);
    if (field === "hotelType") {
      setSelectedType(selectedOption);
      // if (index == 0) {
      setHotelType({
        label: selectedOption.hoteltype,
        value: selectedOption.hoteltypeid,
        // hoteltype: selectedOption.hoteltype,
      });
      // }
      // const mealOptions = await fetchHotelMealPlan(selectedOption.id);

      updatedSelections[index] = {
        ...updatedSelections[index],
        hotelType: selectedOption,
        // options: mealOptions,
        // mealPlan: null,
      };
    } else if (field === "hotelName") {
      // if (index == 0) {
      setSelectedHotelName({
        label: selectedOption.label,
        value: selectedOption.hoteltypeid,
        // hoteltype: selectedOption.hoteltype,
      });
      // }
      const mealOptions = await fetchHotelMealPlan(selectedOption.id);

      updatedSelections[index] = {
        ...updatedSelections[index],
        hotelName: selectedOption,
        options: mealOptions,
        mealPlan: null,
      };
    } else if (field === "mealPlan") {
      if (index == 0) {
        selectedAccommodation(selectedOption);
      }
      setStudentWeekdayTotal(0);
      setStudentWeekendTotal(0);
      setAdultWeekDayTotal(0);
      setAdultWeekendTotal(0);
      updatedSelections[index] = {
        ...updatedSelections[index],
        mealPlan: selectedOption,
      };
    } else if (field === "day") {
      // console.log(selectedOption, "day value ====>>>>");
      updatedSelections[index] = {
        ...updatedSelections[index],
        day: selectedOption,
      };
    } else if (field === "rooms") {
      // console.log(selectedOption, "day value ====>>>>");
      updatedSelections[index] = {
        ...updatedSelections[index],
        noofRooms: selectedOption,
      };
    }
    setSelectedHotel(updatedSelections[0]?.hotelType);
    setHotelSelections(updatedSelections);
  };

  const handleAddDayField = () => {
    setHotelSelections([
      ...hotelSelections,
      { hotelType: null, mealPlan: null, day: null },
    ]);
    setSelectedHotelName(null);
  };

  const handleDeleteDayField = (index) => {
    const updatedSelections = hotelSelections.filter((_, i) => i !== index);
    setHotelSelections(updatedSelections);
  };

  const canDownloadCsv = useMemo(() => {
		if (!selectedPackageType) return false;
		if (isDayouting) return !!hotelSelections?.[0]?.hotelType;
		if (isDayvisit) return true;
		if (isDomestic)
			return !!formValues.noofdays && !!hotelSelections?.[0]?.hotelType;
		if (isDomesticDMC || isInternational) return !!formValues.noofdays;
		return false;
	}, [
		selectedPackageType,
		isDayouting,
		isDayvisit,
		isDomestic,
		isDomesticDMC,
		isInternational,
		hotelSelections,
		formValues.noofdays,
	]);

	const csvDisabledReason = useMemo(() => {
		if (!selectedPackageType) return "Select a package type first";
		if ((isDayouting || isDomestic) && !hotelSelections?.[0]?.hotelType)
			return "Select a property first";
		if (
			(isDomestic || isDomesticDMC || isInternational) &&
			!formValues.noofdays
		)
			return "Enter number of days first";
		return "";
	}, [
		selectedPackageType,
		isDayouting,
		isDomestic,
		isDomesticDMC,
		isInternational,
		hotelSelections,
		formValues.noofdays,
	]);

  const handleDownloadDaywiseCsv = () => {
    const rows = generateDaywiseCsvRows(
      formValues.noofdays || 1,
      hotelSelections,
      transportationSelections,
      returnSelections,
      transferSelections
    );
    const csv = Papa.unparse(rows);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `daywise_plan_${formValues.packagename || "package"}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleUploadDaywiseCsv = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: ({ data }) => {
        const { days: parsedDays, errors } = parseDaywiseCsvRows(
          data,
          allHotelNames,
          onwardTransportOptions,
          returnTransportOptions,
          transferOptions
        );
        if (errors.length > 0) {
          toast.error(errors[0]);
        } else {
          const totalEntries = parsedDays.reduce((n, d) => n + d.timeSlots.length, 0);
          setDays(parsedDays);
          setIsFirstDayAdded(true);
          toast.success(`Day-wise plan loaded from CSV (${parsedDays.length} days, ${totalEntries} entries)`);
        }
      },
      error: () => toast.error("Failed to read CSV file"),
    });
    e.target.value = "";
  };

  // const handleDeleteTransField = (index) => {
  //   const updatedSelections = transportationSelections.filter(
  //     (_, i) => i !== index
  //   );
  //   setTransportationSelections(updatedSelections);
  // };

  // const handleDeleteTransferField = (index) => {
  //   const updatedSelections = transferSelections.filter((_, i) => i !== index);
  //   setTransferSelections(updatedSelections);
  // };

  const handleOpenPriceModal = () => {
    setIsPriceModalOpen(true);
  };

  const handleClosePriceModal = () => {
    setIsPriceModalOpen(false);
  };

  const isInSeason = (startDate, endDate) => {
    if (!startDate || !endDate || !selectedDate) return false;
    const currentDate = new Date(selectedDate);
    const seasonStart = new Date(startDate);
    const seasonEnd = new Date(endDate);
    return currentDate >= seasonStart && currentDate <= seasonEnd;
  };

  const totalAmountStudentWeekDays =
    getHotelPricesWithDays(hotelSelections?.[0]?.options, Number(formValues.noofdays) || 1).student.weekdays +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  const totalAmountStudentWeekends =
    getHotelPricesWithDays(hotelSelections?.[0]?.options, Number(formValues.noofdays) || 1).student.weekends +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  const totalAmountAdultWeekdays =
    getHotelPricesWithDays(hotelSelections?.[0]?.options, Number(formValues.noofdays) || 1).adult.weekdays +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  const totalAmountAdultWeekEnds =
    getHotelPricesWithDays(hotelSelections?.[0]?.options, Number(formValues.noofdays) || 1).adult.weekends +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  return (
    <>
      {isLoading ? (
        <LoaderComponent />
      ) : (
        <div
          onChangeCapture={() => {
            userInteractedRef.current = true;
          }}
          onClickCapture={() => {
            userInteractedRef.current = true;
          }}
          onKeyDownCapture={() => {
            userInteractedRef.current = true;
          }}
        >
          <div className="block md:block lg:flex justify-between">
            <div>
              <h2 className="text-primary-black text-[24px] font-semibold">
                Packages
              </h2>
              <p className="text-[12px]">
                <span className="font-bold">Packages</span> /
                <span className="font-regular">Add Package</span>
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-4 md:my-4 justify-end">
              <Button
                className="w-full md:w-auto"
                label="Convert To Itinerary"
                onClick={handleConvertToItinerary}
              />
              <Button
                className="w-full md:w-auto"
                disabled={!packageData?.packagedetailsid}
                title={!packageData?.packagedetailsid ? "Save the package first to preview" : ""}
                onClick={() => {
                  const id = packageData.packagedetailsid;
                  const slug = slugify(formValues.packagename);
                  window.open(`/view/package/${id}/${slug}`, "_blank");
                }}
                label={
                  <span className="inline-flex items-center gap-1">
                    Preview
                    <span
                      className="material-symbols-outlined ml-2"
                      style={{
                        fontVariationSettings:
                          "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24",
                      }}
                    >
                      open_in_new
                    </span>
                  </span>
                }
              />
              <Button
                className="w-full md:w-auto"
                onClick={() => GeneratePackagePDF({
                  ...(freshPackage ?? {}),
                  packagename: formValues.packagename,
                  packagetype: selectedPackageType?.label,
                  noofdays: Number(formValues.noofdays),
                  noofnights: Number(formValues.noofnights),
                  noofpax: numberOfPax,
                  daywise_plan: days,
                })}
                label={
                  <span className="inline-flex items-center gap-1">
                    Export PDF
                    <span
                      className="material-symbols-outlined ml-2"
                      style={{
                        fontVariationSettings:
                          "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24",
                      }}
                    >
                      picture_as_pdf
                    </span>
                  </span>
                }
              />
              {(user?.role === "Admin" ||
                user?.role === "Backend Team Manager") &&
                selectedValue === "single" && (
                  <Button
                    className="w-full md:w-auto"
                    type="primary"
                    label={isEdit ? "Update" : "Save"}
                    onClick={handleSavePackage}
                  />
                )}
              <Button
                className="w-full md:w-auto"
                type="secondary"
                label="Cancel"
                onClick={handleNavigateBack}
              />
            </div>
          </div>
          <Paper className="my-8 pt-6 pb-6">
            <Paper className="my-8 mt-4 border">
              <h1 className="text-[18px] font-bold mb-4">Package Details</h1>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="col-span-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label className="text-[16px] font-semibold mb-2">
                      Package Type <span className="text-red-500">*</span>
                    </label>

                    <Select
                      options={packageTypeOptions}
                      onChange={handlePackageTypeChange}
                      value={selectedPackageType}
                      placeholder="Select Package Type..."
                    />
                  </div>
                  <div>
                    <label className="text-[16px] font-semibold">
                      Package Name <span className="text-red-500">*</span>
                    </label>
                    <InputText
                      placeholder="Package Name..."
                      name="packagename"
                      value={formValues.packagename}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div>
                    <label className="text-[16px] font-semibold mb-2">
                      Source <span className="text-red-500">*</span>
                    </label>
                    <InputText
                      name="city"
                      value={formValues.city}
                      onChange={handleInputChange}
                      placeholder="Enter source..."
                    />{" "}
                  </div>
                  <div>
                    <label className="text-[16px] font-semibold mb-2">
                      Destination <span className="text-red-500">*</span>
                    </label>
                    <InputText
                      name="destination"
                      value={formValues.destination}
                      onChange={handleInputChange}
                      placeholder="Enter destination..."
                    />{" "}
                  </div>
                  <div>
                    <label className="text-[16px] font-semibold mb-2">
                      Trip Image URL
                    </label>
                    <InputText
                      name="trip_image"
                      value={formValues.trip_image}
                      onChange={handleInputChange}
                      placeholder="Enter trip image URL..."
                    />
                  </div>
                  <div className="col-span-3">
                    <label className="text-[16px] font-semibold mb-2">
                      Description
                    </label>
                    <textarea
                      className="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                      name="description"
                      value={formValues.description}
                      onChange={handleInputChange}
                      placeholder="Enter package description..."
                      rows={3}
                    />
                  </div>
                  {isDayouting ||
                    (!isDayvisit && (
                      <>
                        <div>
                          <label className="text-[16px] font-semibold">
                            No. of Days{" "}
                            {!isDayouting && (
                              <span className="text-red-500">*</span>
                            )}
                          </label>
                          <InputText
                            value={formValues.noofdays}
                            type={"number"}
                            onChange={(e) =>
                              setFormValues((prev) => ({
                                ...prev,
                                noofdays: e.target.value,
                              }))
                            }
                            placeholder="Enter Days Count..."
                          />
                        </div>
                        <div>
                          <label className="text-[16px] font-semibold">
                            No. of Nights{" "}
                            {!isDayouting && (
                              <span className="text-red-500">*</span>
                            )}
                          </label>
                          <InputText
                            value={formValues.noofnights}
                            type={"number"}
                            onChange={(e) =>
                              setFormValues((prev) => ({
                                ...prev,
                                noofnights: e.target.value,
                              }))
                            }
                            placeholder="Enter Nights Count..."
                          />
                        </div>
                      </>
                    ))}
                </div>

                <div className="mt-3">
                  <Upload
                    onFileSelect={handleUploadSelect}
                    labelText="Upload Image"
                    uploadEndpoint="/api/dashboard/upload/package-image"
                    initialPreviewUrl={formData?.logo ? formData?.logo : null}
                    fileValidation={validateFile}
                    handleRemove={() => {
                      setFormData(null);
                    }}
                  />
                  {/* <p className="text-[12px] text-center text-[#ef4444]">Maximum file upload size is 300KB</p> */}
                </div>
              </div>
            </Paper>
            <Paper className="my-8 border p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Main Form Fields */}
                <div className="col-span-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div className="col-span-3 flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                    <h1 className="text-[18px] font-bold">Total Pax and FOC</h1>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                      <div>
                        <label className="text-[16px] font-semibold">
                          No. of Pax <span className="text-red-500">*</span>
                          <span className="text-gray-700 mb-2 pl-1 text-[10px]">
                            Exclude FOC
                          </span>
                        </label>
                        <InputText
                          placeholder="Enter number..."
                          type={"number"}
                          value={numberOfPax}
                          onChange={(e) =>
                            setNumberOfPax(Number(e.target.value))
                          }
                        />{" "}
                      </div>

                      <div>
                        <label className="text-[16px] font-semibold">
                          No. of paid adults
                        </label>
                        <InputText
                          placeholder="Enter No. Paid Adults..."
                          type={"number"}
                          value={paidAdults}
                          onChange={(e) =>
                            setPaidAdults(Number(e.target.value))
                          }
                        />
                      </div>
                      <div>
                        <label className="text-[16px] font-semibold">FOC</label>

                        <Select
                          options={options}
                          value={selectedOption}
                          onChange={handleChange}
                          placeholder="Select FOC..."
                        />
                      </div>
                      <div className="mt-6">
                        <label className="text-[16px] font-semibold">
                          Selected FOC: <b>{selectedFOC}</b>
                        </label>
                      </div>
                    </div>
                  </div>

                  {(isDayouting || isDomestic) && (
                    <div className="col-span-3 flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                      <h1 className="text-[18px] font-bold ">
                        Select Property
                      </h1>
                      {hotelSelections?.map((selection, index) => (
                        <div
                          key={index}
                          className="w-full flex flex-wrap gap-4"
                        >
                          {/* Hotel Type */}
                          <div className="w-auto flex-none">
                            <label className="text-[16px] font-semibold mb-2">
                              Type <span className="text-red-500">*</span>
                            </label>
                            <SearchSelect
                              options={hotelTypeOptions}
                              onChange={(selectedOption) =>
                                handleHotelChanges(
                                  selectedOption,
                                  index,
                                  "hotelType"
                                )
                              }
                              value={
                                hotelTypeOptions.filter(
                                  (option) =>
                                    option.hoteltype ===
                                    selection.hotelType?.hoteltype
                                )[0] || null
                              }
                              placeholder="Select Property Type..."
                              displayLabel="hoteltype"
                            />
                          </div>

                          <div className="w-auto flex-none">
                            <label className="text-[16px] font-semibold mb-2">
                              Name <span className="text-red-500">*</span>
                            </label>

                            <SearchSelect
                              options={hotelNameOptions}
                              onChange={(selectedOption) =>
                                handleHotelChanges(
                                  selectedOption,
                                  index,
                                  "hotelName"
                                )
                              }
                              value={allHotelNames.find(
                                (option) =>
                                  option.label === selection.hotelName?.label
                              )}
                              placeholder="Select Property Name..."
                              displayLabel="name"
                            />
                          </div>

                          {/* Hotel Meal Plan */}
                          <div className="w-auto flex-none">
                            <label className="text-[16px] font-semibold mb-2">
                              Options <span className="text-red-500">*</span>
                            </label>

                            <SearchSelect
                              options={selection?.options || []}
                              placeholder="Select Property Options..."
                              onChange={(selectedOption) =>
                                handleHotelChanges(
                                  selectedOption,
                                  index,
                                  "mealPlan"
                                )
                              }
                              value={selection?.mealPlan || null}
                              isDisabled={!selection.hotelType}
                            />
                          </div>

                          {/* Day */}
                          {isDomestic && (
                            <>
                              <div className="">
                                <label className="text-[16px] font-semibold mb-2">
                                  Select Day <span className="text-red-500">*</span>
                                </label>
                                <MultiNewSelect
                                  placeHolder="Select Days..."
                                  options={dayOptions}
                                  value={selection.day || null}
                                  onChange={(selectedOption) =>
                                    handleHotelChanges(
                                      selectedOption,
                                      index,
                                      "day"
                                    )
                                  }
                                  isMulti
                                  id="fileTypes"
                                />
                                {/* <Select
                                options={dayOptions}
                                placeholder="Select Day..."
                                onChange={(selectedOption) =>
                                  handleHotelChanges(selectedOption, index, "day")
                                }
                                value={selection.day || null}
                              /> */}
                              </div>
                              <div className="">
                                <label className="text-[16px] font-semibold mb-2">
                                  No. of rooms{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <InputText
                                  placeholder="Enter No. of Rooms..."
                                  type={"number"}
                                  value={selection?.noofRooms || 0}
                                  onChange={(selectedOption) =>
                                    handleHotelChanges(
                                      selectedOption.target.value,
                                      index,
                                      "rooms"
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                          {/* Add/Delete Buttons */}
                          {!isDayouting && (
                            <div className="flex gap-2 mt-6">
                              {/* Delete button (hide if only one row) */}
                              {hotelSelections.length > 1 && (
                                <button
                                  className="p-2 rounded bg-red-500 text-white flex justify-center items-center"
                                  onClick={() => handleDeleteDayField(index)}
                                >
                                  <span className="material-symbols-outlined">delete</span>
                                </button>
                              )}

                              {/* Add button (only on last row) */}
                              {index === hotelSelections.length - 1 && (
                                <button
                                  className="p-2 rounded bg-black text-white flex justify-center items-center"
                                  onClick={handleAddDayField}
                                >
                                  <span className="material-symbols-outlined">add</span>
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="col-span-3  flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                    <h1 className="text-[18px] font-bold">
                      Select Transportation
                    </h1>

                    {/* ONWARD TRANSPORTATION */}
                    {transportationSelections?.map((selection, index) => {
                      const selected = selection.selectedOnwardTransport;
                      const vehicalType =
                        selected?.vehicaltype?.toLowerCase?.() || "";

                      const isBus = vehicalType.includes("bus");
                      const isTrainOrFlight =
                        vehicalType.includes("train") ||
                        vehicalType.includes("flight");

                      return (
                        <div
                          key={index}
                          className="grid grid-cols-1 md:grid-cols-3 gap-6"
                        >
                          {/* ✅ Always Show This */}
                          <div>
                            <label className="text-[16px] font-semibold">
                              {transportationSelections?.some((item) =>
                                item?.selectedOnwardTransport?.vehicaltype?.includes(
                                  "seater"
                                )
                              ) || isDomestic
                                ? "Onward Transportation"
                                : "Transportation"}{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <SearchSelect
                              options={filterTransportOptions(
                                onwardTransportOptions,
                                selectedPackageType?.label
                              )}
                              value={selection.selectedOnwardTransport}
                              onChange={(val) =>
                                handleOnwardTransportChange(index, val)
                              }
                              placeholder="Select Onward Transportation..."
                            />
                          </div>

                          {/* ✅ Only show Bus Count section if Domestic, Day Visit, Day Outing, DMC and NOT flight/train */}
                          {(isDayouting ||
                            isDayvisit ||
                            isDomestic ||
                            isDomesticDMC) &&
                            !isTrainOrFlight && (
                              <>
                                <div>
                                  <label className="text-[16px] font-semibold">
                                    Enter Bus Count{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <InputText
                                    type="number"
                                    min="1"
                                    placeholder="Enter Count..."
                                    value={selection.busCount ?? 1}
                                    onChange={(e) =>
                                      handleUpdateBusCount(
                                        index,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <div className="flex gap-2 mt-6">
                                  {/* Add Button - Only show on last row */}
                                  {index ===
                                    transportationSelections.length - 1 && (
                                      <button
                                        className="p-2 rounded bg-black text-white"
                                        onClick={handleAddTransField}
                                      >
                                        <span className="material-symbols-outlined">
                                          add
                                        </span>
                                      </button>
                                    )}

                                  {/* Delete Button - Show if more than one row */}
                                  {transportationSelections.length > 1 && (
                                    <button
                                      className="p-2 rounded bg-red-500 text-white"
                                      onClick={() =>
                                        handleDeleteTransField(index)
                                      }
                                    >
                                      <span className="material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  )}
                                </div>
                              </>
                            )}
                        </div>
                      );
                    })}

                    {/* RETURN & TRANSFER TRANSPORTATION */}
                    {/** NOT Applicable for Day Outing and Day Visit */}
                    {!isDayouting && !isDayvisit && (
                      <>
                        {/* RETURN TRANSPORTATION (Domestic, Domestic DMC, International) */}
                        {!transportationSelections?.some((item) =>
                          item?.selectedOnwardTransport?.vehicaltype?.includes(
                            "seater"
                          )
                        ) &&
                          returnSelections?.map((selection, index) => (
                            <div
                              key={index}
                              className="grid grid-cols-1 md:grid-cols-3 gap-6"
                            >
                              <div>
                                <label className="text-[16px] font-semibold">
                                  Return Transportation{" "}
                                  <span className="text-red-500">
                                    {!transportationSelections?.some((item) =>
                                      item?.selectedOnwardTransport?.vehicaltype?.includes(
                                        "flight"
                                      )
                                    )
                                      ? ""
                                      : "*"}
                                  </span>
                                </label>
                                <SearchSelect
                                  options={filterTransportOptions(
                                    returnTransportOptions,
                                    selectedPackageType?.label
                                  )}
                                  value={selection.selectedReturnTransport}
                                  onChange={(val) =>
                                    handleReturnTransportChange(index, val)
                                  }
                                  placeholder="Select Return Transportation..."
                                />
                              </div>
                            </div>
                          ))}

                        {/* TRANSFER TRANSPORTATION (Only Domestic shows transfers) */}
                        {(isDomestic || isDomesticDMC) &&
                          transferSelections?.map((selection, index) => {
                            const isTrainOrFlight =
                              selection?.selectedTransfers?.label
                                ?.toLowerCase()
                                ?.includes("train") ||
                              selection?.selectedTransfers?.label
                                ?.toLowerCase()
                                ?.includes("flight");

                            return (
                              <div
                                key={index}
                                className="grid grid-cols-1 md:grid-cols-3 gap-6"
                              >
                                <div>
                                  <label className="text-[16px] font-semibold mb-2">
                                    Transfers{" "}
                                    <span className="text-red-500"></span>
                                  </label>
                                  <SearchSelect
                                    options={filterTransferOptions(
                                      transferOptions,
                                      selectedPackageType?.label
                                    )}
                                    value={selection?.selectedTransfers || null}
                                    onChange={(option) =>
                                      handleTransfersChange(option, index)
                                    }
                                    placeholder="Select Transfers..."
                                  />
                                </div>

                                {/* Bus Count only for Domestic Transfers */}
                                {!isTrainOrFlight && (
                                  <>
                                    <div>
                                      <label className="text-[16px] font-semibold">
                                        Enter Bus Count{" "}
                                        <span className="text-red-500"></span>
                                      </label>
                                      <InputText
                                        type="number"
                                        min="1"
                                        placeholder="Enter Count..."
                                        value={selection.busCount ?? 1}
                                        onChange={(e) =>
                                          handleTransferBusCountChange(
                                            index,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>

                                    <div className="flex gap-2 mt-6">
                                      {index ===
                                        transferSelections.length - 1 && (
                                          <button
                                            className="p-2 rounded bg-black text-white"
                                            onClick={handleAddTransferField}
                                          >
                                            <span className="material-symbols-outlined">
                                              add
                                            </span>
                                          </button>
                                        )}
                                      {transferSelections?.length > 1 && (
                                        <button
                                          className="p-2 rounded bg-red-500 text-white"
                                          onClick={() =>
                                            handleDeleteTransferField(index)
                                          }
                                        >
                                          <span className="material-symbols-outlined">
                                            delete
                                          </span>
                                        </button>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                            );
                          })}
                      </>
                    )}
                  </div>

                  <div className="col-span-3 flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                    <h1 className="text-[18px] font-bold">Select Addons</h1>
                    <div className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3 gap-6">
                      <div>
                        <label className="text-[16px] font-semibold mb-2">
                          Addons <span className="text-red-500 ">*</span>
                        </label>
                        <MultiNewSelect
                          placeHolder="Select Addons..."
                          options={addonOptions}
                          value={selectedAddons}
                          onChange={(e) => handleAddonsChange(e, "addons")}
                          isMulti
                          id="fileTypes"
                          isAddons // <-- add this only here
                        />
                        {/* <MultiSelect
                        options={addonOptions}
                        value={selectedAddons}
                        onChange={handleAddonsChange}
                        placeholder="Select Addons..."
                      /> */}
                      </div>

                      {Array.isArray(extraItems) &&
                        extraItems.map(
                          ({ show, label, value, setter }) =>
                            show && (
                              <div key={label}>
                                <label className="text-[16px] font-semibold">
                                  {label}{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <InputText
                                  type="number"
                                  min="1"
                                  placeholder="Enter Count..."
                                  value={value}
                                  onChange={(e) =>
                                    setter(Math.max(1, Number(e.target.value)))
                                  }
                                />
                              </div>
                            )
                        )}
                      <div>
                        <label className="text-[16px] font-semibold">
                          AddOns Calculated Amount{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <InputText
                          placeholder="Enter Amount..."
                          type={"number"}
                          value={Math.round(addOnsAmount)}
                          onChange={(e) =>
                            setAddOnsAmount(Number(e.target.value))
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="text-[16px] font-semibold">
                      Deviation Allowed Amount{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <InputText
                      placeholder="Enter Amount..."
                      type={"number"}
                      value={deviationAmount}
                      onChange={(e) =>
                        setDeviationAmount(Number(e.target.value))
                      }
                    />{" "}
                  </div>
                </div>

                {/* Price Box */}
                <div className="bg-[#CDD8CB] p-6 rounded-lg max-w-sm mx-auto text-left flex flex-col justify-center items-center min-h-[200px]">
                  {/* Content Centered */}
                  <div className="flex items-center gap-1 mb-6">
                    <div className="text-center">
                      <label className="text-[16px] font-semibold mb-0 text-center mb-4">
                        Date of Travel
                      </label>
                      <DatePicker
                        selectedDate={selectedDate}
                        onDateChange={(date) => handleDateChange(date)}
                        placeholderText="Start Date"
                        className="w-full mt-0"
                      />
                    </div>
                  </div>
                  <span className="material-symbols-outlined text-gray-700 text-3xl mb-2">
                    payments
                  </span>
                  <div className="mb-5">
                    <div className="text-gray-700 text-sm mb-2 text-center">
                      Price per Student
                    </div>

                    {selectedPackageType?.label === "Domestic" ? (
                      <>
                        {/* Peak Season */}

                        {offSeasonPrice > 0 && (
                          <div className="text-[22px] font-bold text-black mb-0 text-center">
                            <span className="text-[12px]">Off Season:</span> ₹{" "}
                            {focHandler(
                              Math.round(
                                offSeasonPrice +
                                onWardTrnPrice +
                                returnTrnPrice +
                                transfersPrice +
                                addOnsAmount +
                                deviationAmount +
                                (typeof allMarkups?.student?.offSeason ===
                                  "number"
                                  ? allMarkups.student.offSeason
                                  : markupAmount) +
                                (typeof allGSTValues?.student?.offSeason ===
                                  "number"
                                  ? allGSTValues.student.offSeason
                                  : gstAmount)
                              ),
                              numberOfPax
                            )}
                          </div>
                        )}
                        {peakSeasonPrice > 0 && (
                          <div className="text-[22px] font-bold text-black mb-0 text-center">
                            <span className="text-[12px]">Peak Season:</span> ₹{" "}
                            {focHandler(
                              Math.round(
                                peakSeasonPrice +
                                onWardTrnPrice +
                                returnTrnPrice +
                                transfersPrice +
                                addOnsAmount +
                                deviationAmount +
                                (typeof allMarkups?.student?.peakSeason ===
                                  "number"
                                  ? allMarkups.student.peakSeason
                                  : markupAmount) +
                                (typeof allGSTValues?.student?.peakSeason ===
                                  "number"
                                  ? allGSTValues.student.peakSeason
                                  : gstAmount)
                              ),
                              numberOfPax
                            )}
                          </div>
                        )}

                        {/* Off Season */}
                        {/* {offSeasonPrice > 0 && (
                          <div className="text-[22px] font-bold text-black mb-4 text-center">
                            <span className="text-[12px]">Off Season:</span> ₹{" "}
                            {Math.round(
                              offSeasonPrice +
                                onWardTrnPrice +
                                returnTrnPrice +
                                transfersPrice +
                                addOnsAmount +
                                deviationAmount +
                                markupAmount +
                                gstAmount
                            )}
                          </div>
                        )} */}
                      </>
                    ) : selectedPackageType?.label ===
                      "Day Visit - Local sightseeing" ? (
                      <div className="text-[22px] font-bold text-black mb-0 text-center">
                        ₹{" "}
                        {focHandler(
                          Math.round(
                            totalAmountStudentWeekDays +
                            (allMarkups?.student?.weekdays || 0) +
                            (allGSTValues?.student?.weekdays || 0)
                          ),
                          numberOfPax
                        )}
                      </div>
                    ) : selectedPackageType?.label === "Domestic - DMC" ? (
                      <div className="text-[22px] font-bold text-black mb-0 text-center">
                        ₹{" "}
                        {focHandler(
                          Math.round(
                            totalAmountStudentWeekDays +
                            (allMarkups?.student?.weekdays || 0) +
                            (allGSTValues?.student?.weekdays || 0)
                          ),
                          numberOfPax
                        )}
                      </div>
                    ) : selectedPackageType?.label === "International" ? (
                      <div className="text-[22px] font-bold text-black mb-0 text-center">
                        ₹{" "}
                        {focHandler(
                          Math.round(
                            totalAmountStudentWeekDays +
                            (allMarkups?.student?.weekdays || 0) +
                            (allGSTValues?.student?.weekdays || 0)
                          ),
                          numberOfPax
                        )}
                      </div>
                    ) : (
                      <>
                        {/* Weekdays (Non-domestic fallback) */}
                        {hotelSelections?.length > 0 &&
                          hotelSelections?.[0]?.value != 0 &&
                          totalAmountStudentWeekDays > 0 && (
                            <div className="text-[22px] font-bold text-black mb-0 text-center">
                              <span className="text-[12px]">
                                {selectedPackageType?.label === "International"
                                  ? ""
                                  : "Weekdays:"}
                              </span>
                              ₹{" "}
                              {focHandler(
                                Math.round(
                                  totalAmountStudentWeekDays +
                                  (allMarkups?.student?.weekdays || 0) +
                                  (allGSTValues?.student?.weekdays || 0)
                                ),
                                numberOfPax
                              )}
                            </div>
                          )}

                        {/* Weekends – only show if hotel is selected and totalAmount > 0 */}
                        {hotelSelections?.length > 0 &&
                          hotelSelections?.[0]?.value != 0 &&
                          totalAmountStudentWeekends > 0 && (
                            <div className="text-[22px] font-bold text-black mb-4 text-center">
                              <span className="text-[12px]">Weekends:</span> ₹{" "}
                              {focHandler(
                                Math.round(
                                  totalAmountStudentWeekends +
                                  (allMarkups?.student?.weekends || 0) +
                                  (allGSTValues?.student?.weekends || 0)
                                ),
                                numberOfPax
                              )}
                            </div>
                          )}
                      </>
                    )}
                  </div>

                  {/* {isDayouting && (
                    <div className="mb-5">
                      <div className="text-gray-700 text-sm mb-2 text-center">
                        Price per Adult
                      </div>

                      {hotelSelections?.length > 0 &&
                        hotelSelections?.[0]?.value != 0 &&
                        totalAmountAdultWeekdays > 0 && (
                          <div className="text-[22px] font-bold text-black mb-0 text-center">
                            <span className="text-[12px]">Weekdays:</span> ₹{" "}
                            {focHandler(
                              Math.round(
                                totalAmountAdultWeekdays +
                                (allMarkups?.adult?.weekdays || 0) +
                                (allGSTValues?.adult?.weekdays || 0)
                              ),
                              numberOfPax
                            )}
                          </div>
                        )}

                      {hotelSelections?.length > 0 &&
                        hotelSelections?.[0]?.value != 0 &&
                        totalAmountAdultWeekEnds > 0 && (
                          <div className="text-[22px] font-bold text-black mb-4 text-center">
                            <span className="text-[12px]">Weekends:</span> ₹{" "}
                            {focHandler(
                              Math.round(
                                totalAmountAdultWeekEnds +
                                (allMarkups?.adult?.weekends || 0) +
                                (allGSTValues?.adult?.weekends || 0)
                              ),
                              numberOfPax
                            )}
                          </div>
                        )}
                    </div>
                  )} */}

                  <div className="text-xs text-gray-600 mb-4 text-center">
                    **The above amount is based on the headcount and selected
                    add-ons. It may change if the count is updated. This amount
                    may vary when FOC is applied.
                  </div>

                  {/* Button Centered */}
                  {(user?.role === "Admin" ||
                    user?.role === "Backend Team Manager") && (
                      <button
                        className="bg-transparent text-black border border-black hover:bg-gray-100 h-[40px] md:h-[42px] leading-[10px] text-[16px] md:text-[16px]"
                        onClick={handleOpenPriceModal}
                      >
                        Price Breakdown
                      </button>
                    )}
                </div>

                {isPriceModalOpen && (
                  <div
                    id="modal-overlay"
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={handleClosePriceModal}
                  >
                    <div
                      className="bg-white p-6 rounded-lg shadow-lg max-w-fit w-full relative"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h2 className="text-xl font-bold mb-4">
                        Price Breakdown
                      </h2>
                      <div className="overflow-auto">
                        <table className="table-auto w-full border-collapse md:whitespace-nowrap whitespace-nowrap lg:whitespace-normal">
                          <thead>
                            <tr>
                              <th className="border p-2" rowSpan={2}></th>
                              <th className="border p-2">Property</th>
                              <th className="border p-2" colSpan={3}>
                                Transportation
                              </th>
                              <th className="border p-2">Addons</th>
                              <th className="border p-2" rowSpan={2}>
                                Deviation
                              </th>
                              <th className="border p-2" rowSpan={2}>
                                Markup ({settingsMarkupValue}%)
                              </th>
                              <th className="border p-2" rowSpan={2}>
                                GST ({settingsGSTValue}%)
                              </th>
                              <th className="border p-2" rowSpan={2}>
                                Total Amount
                              </th>
                            </tr>
                            <tr>
                              <th className="border p-2">
                                {hotelSelections?.length
                                  ? hotelSelections
                                    .filter((hotel, index, self) => {
                                      const name =
                                        hotel?.hotelName?.label ??
                                        "No Property";
                                      return (
                                        index ===
                                        self.findIndex(
                                          (h) =>
                                            (h?.hotelName?.label ??
                                              "No Property") === name
                                        )
                                      );
                                    })
                                    .map((hotel, idx, arr) => (
                                      <span key={`hotel-${idx}`}>
                                        <div className="block w-auto break-words lg:w-64">
                                          {hotel?.hotelType?.hoteltype
                                            ? `${hotel.hotelType.hoteltype} - ${hotel?.hotelName?.label ??
                                            "No Property"
                                            }`
                                            : hotel?.hotelName?.label ??
                                            "No Property"}
                                          {idx !== arr.length - 1 && ", "}
                                        </div>
                                      </span>
                                    ))
                                  : "No Property selected"}
                              </th>
                              <th className="border p-2">Onward</th>
                              <th className="border p-2">Return</th>
                              <th className="border p-2">Transfers</th>
                              <th className="border p-2 capitalize">
                                <div className="block w-auto break-words lg:w-64">
                                  {selectedAddons
                                    ?.map((item) => item?.label)
                                    .join(", ")}
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* Student Pricing */}
                            {selectedPackageType?.label === "Domestic" ? (
                              <>
                                {offSeasonPrice > 0 && (
                                  <tr>
                                    <td className="border p-2 text-center font-bold">
                                      Off Season
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {offSeasonPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {onWardTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {returnTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {transfersPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {Math.round(addOnsAmount)}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {deviationAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {allMarkups?.student.offSeason ??
                                        markupAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {allGSTValues?.student.offSeason ??
                                        gstAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {focHandler(
                                        Math.round(
                                          offSeasonPrice +
                                          onWardTrnPrice +
                                          returnTrnPrice +
                                          transfersPrice +
                                          addOnsAmount +
                                          deviationAmount +
                                          (allMarkups?.student.offSeason ??
                                            markupAmount) +
                                          (allGSTValues?.student.offSeason ??
                                            gstAmount)
                                        ),
                                        numberOfPax
                                      )}
                                    </td>
                                  </tr>
                                )}

                                {peakSeasonPrice > 0 && (
                                  <tr>
                                    <td className="border p-2 text-center font-bold">
                                      Peak Season
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {peakSeasonPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {onWardTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {returnTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {transfersPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {Math.round(addOnsAmount)}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {deviationAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {allMarkups?.student.peakSeason ??
                                        markupAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {allGSTValues?.student.peakSeason ??
                                        gstAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {focHandler(
                                        Math.round(
                                          peakSeasonPrice +
                                          onWardTrnPrice +
                                          returnTrnPrice +
                                          transfersPrice +
                                          addOnsAmount +
                                          deviationAmount +
                                          (typeof allMarkups?.student
                                            ?.peakSeason === "number"
                                            ? allMarkups.student.peakSeason
                                            : markupAmount) +
                                          (typeof allGSTValues?.student
                                            ?.peakSeason === "number"
                                            ? allGSTValues.student.peakSeason
                                            : gstAmount)
                                        ),
                                        numberOfPax
                                      )}
                                    </td>
                                  </tr>
                                )}

                                {/* Fallback row: show transport/addon costs when no seasonal hotel pricing */}
                                {offSeasonPrice === 0 && peakSeasonPrice === 0 &&
                                  (onWardTrnPrice > 0 || returnTrnPrice > 0 || transfersPrice > 0 || addOnsAmount > 0) && (
                                  <tr>
                                    <td className="border p-2 text-center font-bold">
                                      Price per head
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ 0
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {onWardTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {returnTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {transfersPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {Math.round(addOnsAmount)}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {deviationAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {markupAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {gstAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {focHandler(
                                        Math.round(
                                          onWardTrnPrice +
                                          returnTrnPrice +
                                          transfersPrice +
                                          addOnsAmount +
                                          deviationAmount +
                                          markupAmount +
                                          gstAmount
                                        ),
                                        numberOfPax
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </>
                            ) : selectedPackageType?.label === "International" ? (
                              ["weekdays"].map((type) => {
                                const studentPrice =
                                  getHotelPricesWithDays(
                                    hotelSelections?.[0]?.options,
                                    Number(formValues.noofdays) || 1
                                  )?.student?.[type] || 0;

                                const hasTransportData =
                                  onWardTrnPrice > 0 ||
                                  returnTrnPrice > 0 ||
                                  transfersPrice > 0 ||
                                  addOnsAmount > 0;

                                if (studentPrice > 0 || hasTransportData) {
                                  return (
                                    <tr key={type}>
                                      <td className="border p-2 text-center font-bold">
                                        Price per head
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {studentPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {onWardTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {returnTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {transfersPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {Math.round(addOnsAmount)}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {deviationAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allMarkups?.student[type] ??
                                          markupAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allGSTValues?.student[type] ?? gstAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {focHandler(
                                          Math.round(
                                            studentPrice +
                                            onWardTrnPrice +
                                            returnTrnPrice +
                                            transfersPrice +
                                            addOnsAmount +
                                            deviationAmount +
                                            (allMarkups?.student[type] > 0
                                              ? allMarkups.student[type]
                                              : markupAmount) +
                                            (allGSTValues?.student[type] > 0
                                              ? allGSTValues.student[type]
                                              : gstAmount)
                                          ),
                                          numberOfPax
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }

                                return null;
                              })
                            ) : selectedPackageType?.label ===
                              "Domestic - DMC" ? (
                              ["weekdays"].map((type) => {
                                const studentPrice =
                                  getHotelPricesWithDays(
                                    hotelSelections?.[0]?.options,
                                    Number(formValues.noofdays) || 1
                                  )?.student?.[type] || 0;

                                const hasTransportData =
                                  onWardTrnPrice > 0 ||
                                  returnTrnPrice > 0 ||
                                  transfersPrice > 0 ||
                                  addOnsAmount > 0;

                                if (studentPrice > 0 || hasTransportData) {
                                  return (
                                    <tr key={type}>
                                      <td className="border p-2 text-center font-bold">
                                        Price per head
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {studentPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {onWardTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {returnTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {transfersPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {Math.round(addOnsAmount)}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {deviationAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allMarkups?.student[type] ??
                                          markupAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allGSTValues?.student[type] ?? gstAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {focHandler(
                                          Math.round(
                                            studentPrice +
                                            onWardTrnPrice +
                                            returnTrnPrice +
                                            transfersPrice +
                                            addOnsAmount +
                                            deviationAmount +
                                            (allMarkups?.student[type] > 0
                                              ? allMarkups.student[type]
                                              : markupAmount) +
                                            (allGSTValues?.student[type] > 0
                                              ? allGSTValues.student[type]
                                              : gstAmount)
                                          ),
                                          numberOfPax
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }

                                return null;
                              })
                            ) : selectedPackageType?.label ===
                              "Day Visit - Local sightseeing" ? (
                              ["weekdays"].map((type) => {
                                const studentPrice =
                                  getHotelPricesWithDays(
                                    hotelSelections?.[0]?.options,
                                    Number(formValues.noofdays) || 1
                                  )?.student?.[type] || 0;

                                const hasTransportData =
                                  onWardTrnPrice > 0 ||
                                  returnTrnPrice > 0 ||
                                  transfersPrice > 0 ||
                                  addOnsAmount > 0;

                                if (studentPrice > 0 || hasTransportData) {
                                  return (
                                    <tr key={type}>
                                      <td className="border p-2 text-center font-bold">
                                        Price per head
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {studentPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {onWardTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {returnTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {transfersPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {Math.round(addOnsAmount)}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {deviationAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allMarkups?.student[type] ??
                                          markupAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allGSTValues?.student[type] ?? gstAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {focHandler(
                                          Math.round(
                                            studentPrice +
                                            onWardTrnPrice +
                                            returnTrnPrice +
                                            transfersPrice +
                                            addOnsAmount +
                                            deviationAmount +
                                            (allMarkups?.student[type] > 0
                                              ? allMarkups.student[type]
                                              : markupAmount) +
                                            (allGSTValues?.student[type] > 0
                                              ? allGSTValues.student[type]
                                              : gstAmount)
                                          ),
                                          numberOfPax
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }

                                return null;
                              })
                            ) : (
                              ["weekdays", "weekends"].map((type) => {
                                // console.log(
                                //   "hotelSelections?.[0]?.value:",
                                //   hotelSelections?.[0]?.value
                                // );
                                const hotelSelected =
                                  String(hotelSelections?.[0]?.value) !== "0";
                                const studentPrice =
                                  getHotelPricesWithDays(
                                    hotelSelections?.[0]?.options,
                                    Number(formValues.noofdays) || 1
                                  )?.student?.[type] || 0;

                                const hasTransportData =
                                  onWardTrnPrice > 0 ||
                                  returnTrnPrice > 0 ||
                                  transfersPrice > 0 ||
                                  addOnsAmount > 0;

                                if (
                                  hotelSelected &&
                                  (studentPrice > 0 || hasTransportData)
                                ) {
                                  return (
                                    <tr key={type}>
                                      <td className="border p-2 text-center font-bold">
                                        Student ({type})
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {studentPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {onWardTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {returnTrnPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {transfersPrice}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {Math.round(addOnsAmount)}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹ {deviationAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allMarkups?.student[type] ??
                                          markupAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {allGSTValues?.student[type] ?? gstAmount}
                                      </td>
                                      <td className="border p-2 text-center">
                                        ₹{" "}
                                        {focHandler(
                                          Math.round(
                                            studentPrice +
                                            onWardTrnPrice +
                                            returnTrnPrice +
                                            transfersPrice +
                                            addOnsAmount +
                                            deviationAmount +
                                            (allMarkups?.student[type] > 0
                                              ? allMarkups.student[type]
                                              : markupAmount) +
                                            (allGSTValues?.student[type] > 0
                                              ? allGSTValues.student[type]
                                              : gstAmount)
                                          ),
                                          numberOfPax
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }

                                return null;
                              })
                            )}

                            {/* Adult Pricing */}
                            {["weekdays", "weekends"].map((type) => {
                              const hotelSelected =
                                hotelSelections?.[0]?.value !== "0"; // Check if hotel is selected
                              const adultPrice =
                                getHotelPricesWithDays(
                                  hotelSelections?.[0]?.options,
                                  Number(formValues.noofdays) || 1
                                )?.adult[type] || 0;

                              return (
                                hotelSelected &&
                                adultPrice > 0 && (
                                  <tr key={`adult-${type}`}>
                                    <td className="border p-2 text-center font-bold">
                                      Adult ({type})
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {adultPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {onWardTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {returnTrnPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {transfersPrice}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {Math.round(addOnsAmount)}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹ {deviationAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {allMarkups?.adult[type]
                                        ? allMarkups?.adult[type]
                                        : markupAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {allGSTValues?.adult[type]
                                        ? allGSTValues?.adult[type]
                                        : gstAmount}
                                    </td>
                                    <td className="border p-2 text-center">
                                      ₹{" "}
                                      {focHandler(
                                        Math.round(
                                          adultPrice +
                                          onWardTrnPrice +
                                          returnTrnPrice +
                                          transfersPrice +
                                          addOnsAmount +
                                          deviationAmount +
                                          (allMarkups?.adult[type]
                                            ? allMarkups?.adult[type]
                                            : markupAmount) +
                                          (allGSTValues?.adult[type]
                                            ? allGSTValues?.adult[type]
                                            : gstAmount)
                                        ),
                                        numberOfPax
                                      )}
                                    </td>
                                  </tr>
                                )
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <button
                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                        onClick={handleClosePriceModal}
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </Paper>

            <div className="bg-white rounded-xl border-gray-300 p-4 my-8 border">
              <div className="flex items-center justify-between mb-4">
                <h1 className="text-[20px] font-bold">Day-wise Planning</h1>
                <div className="flex gap-2">
                  <button
                    type="button"
                    onClick={handleDownloadDaywiseCsv}
                    disabled={!canDownloadCsv}
                    title={csvDisabledReason}
                    className="flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    ⬇ Download CSV Template
                  </button>
                  <label
                    className="flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 cursor-pointer"
                    title="Upload a filled CSV to replace the day-wise plan"
                  >
                    ⬆ Upload CSV
                    <input
                      type="file"
                      accept=".csv"
                      className="hidden"
                      onChange={handleUploadDaywiseCsv}
                    />
                  </label>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4">
                {!isFirstDayAdded ? (
                  <Paper className="border-2 border-dashed border-black p-8  flex justify-center items-center flex-col">
                    <button
                      onClick={handleAddDay}
                      className=" bg-white text-black border border-black rounded-md py-2 px-12 text-lg mb-4 mt-4"
                    >
                      Add Day
                    </button>
                    <p className="text-center text-gray-500 mt-4">
                      No day plan to display
                    </p>
                  </Paper>
                ) : (
                  <div className="grid grid-cols-1 lg:grid-cols-2 items-start gap-4">
                    {days.map((day, index) => (
                      <div key={day.dayNumber} className="w-full">
                        <DayPlan
                          dayNumber={day.dayNumber}
                          initialTimeSlots={day.timeSlots}
                          planName01={day.planName}
                          daywiseImage={day.daywiseImage}
                          setDays={setDays}
                          onChange={(planData) => {
                            handleDayPlanChange(planData?.dayNumber, planData);
                          }}
                          onDelete={() => handleDeleteDay(day.dayNumber)}
                          isFirstDay={index === 0}
                          isLastDay={index === days.length - 1}
                          onMoveUp={() => handleMoveDayUp(index)}
                          onMoveDown={() => handleMoveDayDown(index)}
                          onwardTransportOptions={onwardTransportOptions}
                          returnTransportOptions={returnTransportOptions}
                          transferOptions={transferOptions}
                          hotelNameOptions={allHotelNames}
                          hotelTypeOptions={hotelTypeOptions}
                        />
                      </div>
                    ))}

                    <Paper className="border-2 border-dashed border-black p-8  flex justify-center items-center flex-col">
                      <button
                        onClick={handleAddDay}
                        className=" bg-white text-black border border-black rounded-md py-2 px-12 text-lg"
                      >
                        Add Day
                      </button>
                    </Paper>
                  </div>
                )}
              </div>
            </div>
            <div className="container mx-auto py-6">
              <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6">
                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Transportation Details{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <TextEditor
                    initialValue={editorContents.transportation_details}
                    onChange={(content) =>
                      handleEditorChange(content, "transportation_details")
                    }
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Hotel Details <span className="text-red-500">*</span>
                  </label>
                  <TextEditor
                    initialValue={editorContents.hotel_details}
                    onChange={(content) =>
                      handleEditorChange(content, "hotel_details")
                    }
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Meal Plan <span className="text-red-500">*</span>
                  </label>
                  <TextEditor
                    initialValue={editorContents.meal_plan}
                    onChange={(content) =>
                      handleEditorChange(content, "meal_plan")
                    }
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Inclusions <span className="text-red-500">*</span>
                  </label>
                  <TextEditor
                    initialValue={editorContents.inclusions}
                    onChange={(content) =>
                      handleEditorChange(content, "inclusions")
                    }
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Exclusions<span className="text-red-500">*</span>
                  </label>
                  <TextEditor
                    initialValue={editorContents.exclusions}
                    onChange={(content) =>
                      handleEditorChange(content, "exclusions")
                    }
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Terms and Conditions<span className="text-red-500">*</span>
                  </label>
                  <TextEditor
                    initialValue={editorContents.terms_conditions}
                    onChange={(content) =>
                      handleEditorChange(content, "terms_conditions")
                    }
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Learning Outcomes<span className="text-red-500">*</span>
                  </label>
                  <TextEditor
                    initialValue={editorContents.learning_outcomes}
                    onChange={(content) =>
                      handleEditorChange(content, "learning_outcomes")
                    }
                  />
                </div>

                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Payment Plan
                  </label>
                  <TextEditor
                    initialValue={editorContents.payment_plan}
                    onChange={(content) =>
                      handleEditorChange(content, "payment_plan")
                    }
                  />
                </div>

                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Cancellation Policy
                  </label>
                  <TextEditor
                    initialValue={editorContents.cancellation_policy}
                    onChange={(content) =>
                      handleEditorChange(content, "cancellation_policy")
                    }
                  />
                </div>

                <div>
                  <label className="text-[16px] font-semibold mb-4 block">
                    Notes
                  </label>
                  <TextEditor
                    initialValue={editorContents.notes}
                    onChange={(content) =>
                      handleEditorChange(content, "notes")
                    }
                  />
                </div>
              </div>
            </div>
            {isModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                <div className="bg-white rounded-lg p-6 w-96">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">Convert to Itinerary</h2>
                    <button
                      onClick={() => { setIsModalOpen(false); setIsPublicItinerary(false); setSelectedInstitution(null); }}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <span className="material-symbols-outlined">close</span>
                    </button>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <label className="text-[16px] font-semibold mb-0 text-center mb-4">
                        Date of Travel
                      </label>
                      <DatePicker
                        selectedDate={selectedDate}
                        onDateChange={(date) => handleDateChange(date)}
                        placeholderText="Start Date"
                        className="w-full mt-0"
                      />
                    </div>
                    <div>
                      <label className="text-[16px] font-semibold mb-2 block">
                        Itinerary Name<span className="text-red-500">*</span>
                      </label>
                      <InputText
                        placeholder="Enter itinerary name..."
                        value={itineraryName}
                        onChange={(e) => setItineraryName(e.target.value)}
                      />
                    </div>

                    <div className="flex items-center justify-between">
                      <label className="text-[16px] font-semibold">
                        Public Itinerary
                      </label>
                      <button
                        type="button"
                        onClick={() => {
                          setIsPublicItinerary((prev) => !prev);
                          setSelectedInstitution(null);
                        }}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
                          isPublicItinerary ? "bg-green-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
                            isPublicItinerary ? "translate-x-5" : "translate-x-0.5"
                          }`}
                        />
                      </button>
                    </div>

                    {!isPublicItinerary && (
                      <div>
                        <label className="text-[16px] font-semibold mb-2 block">
                          Select Institution<span className="text-red-500">*</span>
                        </label>
                        <SearchSelect
                          options={institutionOptions}
                          onChange={handleInstitutionSelect}
                          value={selectedInstitution}
                          placeholder="Select Institution..."
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex justify-end gap-2 mt-6">
                    <Button
                      type="secondary"
                      label="Cancel"
                      onClick={() => {
                        setIsModalOpen(false);
                        setIsPublicItinerary(false);
                        setSelectedInstitution(null);
                      }}
                    />
                    <Button
                      type="primary"
                      label={isSubmittingItinerary ? "Submitting..." : isPublicItinerary ? "Create Itinerary" : "Add Enquiry"}
                      onClick={handleConvertToEnquiry}
                      disabled={isSubmittingItinerary || (!isPublicItinerary && !selectedInstitution) || !itineraryName}
                    />
                  </div>
                </div>
              </div>
            )}
          </Paper>
          <ToastContainer />
        </div >
      )}
    </>
  );
};

export default AddPackages;
